import _ from './underscore';
import $ from './jquery-2.2.0';
import './radresponder.csrf';
import './radresponder.polyfills';
import './radresponder.logoffprompt';

window.RadResponder = window.RadResponder || {};

RadResponder.getRootAddress = function () {
    return location.protocol + "//" + location.host + RadResponder.getHostPath(location.pathname, false);
};

//Use this method instead of getRootAddress on MVC views
RadResponder.getAddress = function () {
    var virtualDirectoryPath = document.getElementById("virtualDirectoryPath").value;
    return location.protocol + "//" + location.host + virtualDirectoryPath;
};

RadResponder.getApiAddress = function () {
    return document.getElementById("apiAddress").value;
};

RadResponder.getExternalApiAddress = function () {
    return document.getElementById("externalApiAddress").value;
};

RadResponder.getAppName = function () {
    return document.getElementById('appName').value;
};

RadResponder.getWebsiteAddress = function () {
    return document.getElementById("websiteAddress").value;
};

RadResponder.getResourceAddress = function () {
    return document.getElementById("resourcesAddress").value;
};

RadResponder.getIdentityAddress = function () {
    return document.getElementById("identityAddress").value;
};

RadResponder.simulationManualLink = 'https://www.radresponder.net/app/index#resources/documents/download/1555';

RadResponder.getUrlParameterByName = function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

RadResponder.goToOrReload = function (url) {
    var urlParts = url.split("#");
    var hash = "#" + urlParts[1];
    var pathName = urlParts[0];

    //url is exactly the same, just reload
    if (window.location.pathname === pathName && window.location.hash === hash) {
        window.location.reload();
        return;
    }

    //if page is completely different, navigate
    if (window.location.pathname !== pathName) {
        window.location.hash = hash;
        window.location.href = pathName;
        return;
    }

    //if only hash changed, update it and manually reload
    window.location.hash = hash;
    //window.location.reload();
};

RadResponder.setModalMaxHeight = function () {
    $(".modal-on-window-reize").each(function (index, obj) {
        obj.style.maxHeight = $(window).height() - 100 + "px";
        obj.style.overflow = "auto";
    });
};

RadResponder.isSiteSSL = function () {
    return location.protocol == "https:";
};

RadResponder.getApplicationAddress = function () {
    return location.protocol + "//" + location.host + RadResponder.getHostPath(location.pathname, true);
};

RadResponder.getUrlHash = function (url) {
    if (!url) {
        url = location.href;
    }
    return url.indexOf("#") > -1 ? url.substring(url.indexOf("#") + 1) : "";
};

RadResponder.getHostPath = function (path, includeApplication) {
    var location = "";
    var pathParts = path.split("/");

    for (var i = 0; i < pathParts.length - 1; i++) {
        if (pathParts[i] != "") {
            if (pathParts[i].toLowerCase() === "application" && !includeApplication) {
                break;
            }

            location += "/" + pathParts[i];

            if (pathParts[i].toLowerCase() === "application" && includeApplication) {
                break;
            }
        }
    }

    return location + "/";
};

RadResponder.getScript = function (src, callback) {
    var s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.onreadystatechange = s.onload = function () {
        if (!callback.done && (!s.readyState || /loaded|complete/.test(s.readyState))) {
            callback.done = true;
            callback();
        }
    };
    document.querySelector("head").appendChild(s);
};


RadResponder.urlModifier = (function () {
    var urlModifierInputId = 'urlModifier';
    var selector = document.getElementById(urlModifierInputId);
    if (!selector) {
        return null;
    }

    return selector.value;
})();

RadResponder.daysDiffFromToday = function (date) {
    return Math.ceil(date.diff(moment.utc(), "minutes") / (60 * 24));
};

RadResponder.isDebug = false;
RadResponder.configureApplicationInsights = function (key) {
    var init = new Microsoft.ApplicationInsights.ApplicationInsights({
        config: {
            instrumentationKey: key,
            enableAutoRouteTracking: true,
            autoTrackPageVisitTime: true
        }
    });
    window.appInsights = init.loadAppInsights();
    window.appInsights.trackPageView();
};



RadResponder.cardinalDirections = [
    { Name: "North", Value: 0, Key: 1 },
    { Name: "North North East", Value: 22.5, Key: 2 },
    { Name: "North East", Value: 45, Key: 3 },
    { Name: "East North East", Value: 67.5, Key: 4 },
    { Name: "East", Value: 90, Key: 5 },
    { Name: "East South East", Value: 112.5, Key: 6 },
    { Name: "South East", Value: 135, Key: 7 },
    { Name: "South South East", Value: 157.5, Key: 8 },
    { Name: "South", Value: 180, Key: 9 },
    { Name: "South South West", Value: 202.5, Key: 10 },
    { Name: "South West", Value: 225, Key: 11 },
    { Name: "West South West", Value: 247.5, Key: 12 },
    { Name: "West", Value: 270, Key: 13 },
    { Name: "West North West", Value: 292.5, Key: 14 },
    { Name: "North West", Value: 315, Key: 15 },
    { Name: "North North West", Value: 337.5, Key: 16 }];

RadResponder.getCardinalDirections = function () {
    var options = RadResponder.cardinalDirections;
    options.push({ Name: "Please select a direction", Value: null, Key: null });
    return options;
};

RadResponder.areCoordinatesValid = function (lat, long) {
    return lat >= -90 && lat <= 90 && long >= -180 && long <= 180;
};

RadResponder.FieldSurveySeverityLevelLookup = [
    { Name: "Unable to Calculate", Value: 106 },
    { Name: "Pending", Value: 105 },
    { Name: "Background", Value: 100 },
    { Name: "Low", Value: 101 },
    { Name: "Medium", Value: 102 },
    { Name: "High", Value: 103 },
    { Name: "Very High", Value: 104 }
];

RadResponder.severityLevelInformation = function (data, showNullAsNull) {
    if (showNullAsNull === true && data === null) {
        return {
            name: "--",
            cssClass: null
        };
    } else if (isNaN(data) || data === RadResponder.severityLevels.unableToCalculate) {
        return {
            name: "Unable to Calculate",
            cssClass: "pending"
        };
    } else if (data === RadResponder.severityLevels.pending || data === null) {
        return {
            name: "Pending",
            cssClass: "pending"
        };
    } else if (!data) {
        return {
            name: "Background",
            cssClass: "background"
        };
    } else if (data >= 1 && data < 2) {
        return {
            name: "Low",
            cssClass: "low"
        };
    } else if (data >= 2 && data < 3) {
        return {
            name: "Medium",
            cssClass: "medium"
        };
    } else if (data >= 3 && data < 4) {
        return {
            name: "High",
            cssClass: "high"
        };
    } else {
        return {
            name: "Very high",
            cssClass: "very-high"
        };
    }
};
RadResponder.severityLevelToString = function (data, showNullAsNull) {
    return RadResponder.severityLevelInformation(data, showNullAsNull).name;
};
RadResponder.severityLevelToCssClass = function (data, showNullAsNull) {
    return RadResponder.severityLevelInformation(data, showNullAsNull).cssClass;
};
RadResponder.severityLevelToBadge = function (data, showNullAsNull, row) {
    if (row && row.Is_Obfuscated) {
        return "--";
    }
    var labelClass = RadResponder.severityLevelToCssClass(data, showNullAsNull);
    var information = RadResponder.severityLevelToString(data, showNullAsNull);
    if (RadResponder.isEmpty(labelClass)) {
        return information;
    }
    return "<span class=\"label label-as-badge severity " + labelClass + "\">" + information + "</span>";
};

RadResponder.thresholdRangeToBadge = function (numberColumn, textColumn) {
    return function (data, showNullAsNull, row) {
        if (row && row.Is_Obfuscated) {
            return RadResponder.defaultValue;
        }
        var labelClass = 'range' + ((row[textColumn || 'Threshold_Range_Number']) || '-none');
        var information = row[numberColumn || 'Threshold_Range_Label'] || 'Unable to Calculate';
        if (RadResponder.isEmpty(labelClass)) {
            return information;
        }
        return "<span class=\"label label-as-badge severity " + labelClass + "\">" + information + "</span>";
    };
};

RadResponder.assessmentStatuses = [
    { Name: "Pending Assessment", Value: 1 },
    { Name: "Accepted", Value: 4 },
    { Name: "Rejected", Value: 5 },
    { Name: "Suspect", Value: 100 }
];

RadResponder.mobileResourceSetAudienceTypeOptions = {
    organizationRole: "organizationRole",
    specificPeople: "specificPeople",
    event: "event",
    organization: "organization",
    everyone: "everyone",
    fieldTeam: "fieldTeam",
    eventRole: "eventRole"
};

RadResponder.mobileResourceSetAudienceTypeDisplay = function (data) {
    switch (data) {
        case RadResponder.mobileResourceSetAudienceTypeOptions.organizationRole:
            return "Roles (Organization)";
        case RadResponder.mobileResourceSetAudienceTypeOptions.specificPeople:
            return "Specific People";
        case RadResponder.mobileResourceSetAudienceTypeOptions.event:
            return "Events";
        case RadResponder.mobileResourceSetAudienceTypeOptions.organization:
            return "Organizations";
        case RadResponder.mobileResourceSetAudienceTypeOptions.everyone:
            return "Everyone";
        case RadResponder.mobileResourceSetAudienceTypeOptions.fieldTeam:
            return "Field Teams";
        case RadResponder.mobileResourceSetAudienceTypeOptions.eventRole:
            return "Roles (Event)";
        default:
            return "--";
    }
};



RadResponder.termsOfUseTypes = {
    developer: 100,
    responder: 101
};

RadResponder.equipmentTypes = {
    meter: 100,
    probe: 102,
    gasMeter: 124,
    photoionizationDetector: 132,
    combustibleGasIndicator: 142,
    dosimeter: 144,
    sensor: 149
};

RadResponder.deviceTypes = {
    standard: 100,
    meter: 101,
    sensor: 102
};

RadResponder.locationOptions = {
    map: "map",
    latLong: "latlong",
    address: "address",
    samplingLocation: "samplinglocation",
    facility: "facility",
    tenPointMonitoringPlan: "tenpointmonitoringplan",
    eventReleasePoint: "eventreleasepoint",
    existingLocation: "existinglocation"
};

RadResponder.organizationClasses = {
    federal: 100,
    state: 101,
    local: 102,
    universityAcademia: 103,
    associationNonProfit: 104,
    nuclearPowerPlant: 105,
    hospital: 106,
    dODNationalGuard: 107,
    laboratory: 108,
    corporate: 109,
    tribal: 110,
    other: 111,
};

RadResponder.personnelTrustLevels = {
    fullTrust: 100,
    restricted: 101
};

RadResponder.organizationTrustLevels = {
    fullTrust: 100,
    restricted: 101
};

RadResponder.fieldTeamTypes = {
    dataCollection: 100,
    hotline: 101
};

RadResponder.roleTypes = {
    organizationRoles: 1000,
    defaultEventRoles: 1001
};

RadResponder.organizationRoles = {
    administrator: 100,
    planner: 101,
    equipmentManager: 102,
    personnelManager: 103,
    eventCreator: 104,
    dataCollector: 105,
    dataAssessor: 106,
    dataViewer: 107,
    aPIClientManager: 108,
    dataViewerApprovedDataOnly: 109,
    eventManager: 110,
    teamManager: 111,
    dosimetryManagerOrganization: 112,
    dosimetryManager: 113,
    dosimetryViewer: 114,
    laboratoryManager: 115,
    laboratoryViewer: 116,
    assessmentManager: 117,
    pio: 118,
    pioEvent: 119
};

RadResponder.organizationEventRoles = [
    RadResponder.organizationRoles.dataCollector,
    RadResponder.organizationRoles.dataAssessor,
    RadResponder.organizationRoles.dataViewer,
    RadResponder.organizationRoles.dataViewerApprovedDataOnly,
    RadResponder.organizationRoles.eventManager,
    RadResponder.organizationRoles.teamManager,
    RadResponder.organizationRoles.dosimetryManager,
    RadResponder.organizationRoles.dosimetryViewer,
    RadResponder.organizationRoles.pioEvent
]



RadResponder.measurementSourceIds = {
    website: 2,
    epa: 4,
    simulatedData: 8,
    earlyDataEntry: 11,
    otherAgency: 18,
    ecam: 118,
    dfmTablet: 218,
    mfkDataImport: 219,
    android: 220,
    ios: 221,
    windows: 222,
    bulkImport: 322,
    windowsClient: 422,
    publicApiV1: 522,
    publicApiV2: 622,
    ims: 722
};

RadResponder.personnelSavedConfigurationViews = {
    eventMap: 1
};

RadResponder.fieldMeasurementClassifications = {
    fieldSurvey: 100,
    spectrumExposure: 101,
    fieldScreening: 102,
    sampleContactDoseRate: 103
};

RadResponder.organizationClassSupportsEvents = function (classId) {
    if (classId === RadResponder.organizationClasses.laboratory) {
        return false;
    }
    return true;
};

RadResponder.organizationRoleSpecificTypes = function () {
    var specificRoles = [];
    var addRoleType = function (roleId, eventOnly, labOnly) {
        specificRoles.push({ roleId: roleId, eventOnly: eventOnly, labOnly: labOnly });
    };

    //Event Only
    addRoleType(RadResponder.organizationRoles.aPIClientManager, true, false);
    addRoleType(RadResponder.organizationRoles.dosimetryManagerOrganization, true, false);
    addRoleType(RadResponder.organizationRoles.dosimetryManager, true, false);
    addRoleType(RadResponder.organizationRoles.equipmentManager, true, false);
    addRoleType(RadResponder.organizationRoles.eventCreator, true, false);
    addRoleType(RadResponder.organizationRoles.planner, true, false);
    addRoleType(RadResponder.organizationRoles.dataCollector, true, false);
    addRoleType(RadResponder.organizationRoles.dataViewer, true, false);
    addRoleType(RadResponder.organizationRoles.dataViewerApprovedDataOnly, true, false);
    addRoleType(RadResponder.organizationRoles.dataAssessor, true, false);
    addRoleType(RadResponder.organizationRoles.eventManager, true, false);
    addRoleType(RadResponder.organizationRoles.teamManager, true, false);
    addRoleType(RadResponder.organizationRoles.dosimetryViewer, true, false);

    //Lab Only
    addRoleType(RadResponder.organizationRoles.laboratoryManager, false, true);
    addRoleType(RadResponder.organizationRoles.laboratoryViewer, false, true);
    return specificRoles;

};

RadResponder.assessmentStatus = {
    pending:null,
    underReview: 100,
    passedReview: 101,
    failedReview: 102
};

RadResponder.assessmentStatusDisplay = function (data) {
    switch (data) {
        case RadResponder.assessmentStatus.pending:
            return "Pending";
        case RadResponder.assessmentStatus.underReview:
            return "Under Review";
        case RadResponder.assessmentStatus.passedReview:
            return "Passed Review";
        case RadResponder.assessmentStatus.failedReview:
            return "Failed Review";
        default:
            return "--";
    }
};

RadResponder.mdaOptions = {
    all: null,
    lessThanMda: 1,
    notLessThanMda: 2
}

RadResponder.analysisStatus = {
    pending: 1,
    accepted: 4,
    rejected: 5,
    suspect: 100
};

RadResponder.mapTypes = {
    event: 100,
    network: 101,
    activeEvents: 102
};

RadResponder.infoboxTypes = {
    legacy: 100,
    quickDetails: 101
};

RadResponder.fieldSampleTypes = {
    air: 100,
    milk: 104,
    soil: 106,
    water: 110,
    swipe: 114,
    other: 112,
    feed: 119,
    food: 117,
    vegetation: 115,
    groundDeposition: 519
};
RadResponder.measurementTypes = {
    alpha: 2,
    beta: 3,
    gamma: 5,
    gross: 205,
    neutron: 105,
    betagamma: 305
};

RadResponder.fieldSampleSubTypes = {
    cartridge: 100,
    filter: 101,
    core: 102,
    surface: 103,
    surfaceWater: 104,
    groundWell: 105,
    tapWater: 106,
    other: 107,
    dairy: 108,
    egg: 109,
    fish: 110,
    grain: 111,
    meat: 112,
    leafy: 113,
    fruit: 114,
    root: 115,
    otherEdible: 116,
    impactor: 117
};

RadResponder.dataPointTypes = {
    releasePoint: -1,

    observation: 100,
    sample: 101,
    survey: 102,
    equipment: 104,
    organization: 105,
    spectra: 108,
    document: 109,
    event: 112,
    set: 113,
    result: 115,
    responder: 116,
    fixedPointSurvey: 117,
    aerialSurvey: 118,
    aerialReading: 119,
    directory: 120,
    tool: 121,
    video: 122,
    training: 123,
    sitrep: 124,
    facility: 126,
    samplingLocation: 127,
    chemicalId: 128,
    colorimetricReading: 130,
    lessonLearned: 131,
    dose: 132,
    accumulatedDose: 133,
    userDrawing: 134,
    radnetLocation: 135,
    assignment: 136,
    imaacModel: 137,
    imaacModelRequest: 138,
    tenPointPlanPoint: 139,
    tenPointPlanShelterZone: 140,
    tenPointPlanHotZone: 141,
    tenPointPlanTransect: 142,
    tenPointPlanGridLine: 143,
    floorPlan: 144,
    dataFeedLocation: 145,
    ross: 146,
    eventFacility: 147,
    eventRadius: 148,
    chemicalReading: 149,
    chemicalSpectra: 150,
    analysisRequest: 151,
    archivedDataFeedLocation: 152,
    dataVerification: 153,
    dataPointAttachment: 154,
    fixedChemicalReading: 157,
    fieldScreening: 158,
    laboratory: 159,
    dataPointAssociation: 160,
    messageBoard: 161,
    mobileSurveySegment: 162,
    responderTrackingSegment: 163,    
    imsLocation: 164,
    bioScreening: 165,
    bioSitrep: 166,
    fieldTeam: 169,
    nonConformance: 171,
    mixture: 226,
    module: 230,
    chemicalSample: 233,
    resourceLibrary: 234,
    resourceLibraryFolder: 235,
    activityLog: 236,
    alertDefinition: 237,
    alertHistory: 238,
    bioSample: 239,
    chemicalAnalyticalResult: 240,
    nppPlanGridLine: 241,
    nppPlanTransect: 242,
    equipmentTemplate: 243,
    radiologicalSpectrumExposure: 244,
    dataFeedLocationDevice: 245,
    indoorSamplingLocation: 246,
    concentrationResult: 247,
    vspLocationPoint: 248,
    fieldSampleContactDoseRate: 249
};

RadResponder.mapPointTypes = {
    cluster: 1,
    responderTrackingPathPoint: 2,
    point: 4,
    polyline: 5,
    polygon: 6,
    circle: 7,
    rddPoint: 8,
    rddPolyline: 9,
    rddPolygon: 10,
    kmlFileElement: 11,
    imaacFileElement: 12,
    shapeFileElement: 13,
    nppElement: 14,
    multigeometry: 15,
    groundOverlay: 16,
};

RadResponder.drawingTypes = {
    editTool: -1,
    eraseTool: -2,

    point: 100,
    polyline: 103,
    circle: 101,
    polygon: 102,
    rectangle: 104
};
RadResponder.isDrawingTypeAPolygon = function (drawingTypeId) {
    return drawingTypeId === RadResponder.drawingTypes.polygon
        || drawingTypeId === RadResponder.drawingTypes.rectangle
        || drawingTypeId === RadResponder.drawingTypes.circle
}

RadResponder.warningTypes = {
    noDataFileWarning: "HideNoDataFileWarning",
    noInstrumentWarning: "HideNoInstrumentWarning"
};

RadResponder.importTypes = {
    analyticalResult: 100,
    fieldSample: 101,
    survey: 102,
    spectrum: 103,
    radiologicalEquipment: 104,
    samplingLocation: 105,
    releaseNotes: 106,
    chemicalEquipment: 107,
    eventAAL: 108,
    analysisRequest: 109,
    mobileSurveyReading: 110,
    assignment: 111,
    bioScreening: 112,
    equipmentMaintenance: 113,
    facility: 114,
    chemicalAnalyticalResult: 115,
    vspSamplingPlan: 116
};

RadResponder.importStatuses = {
    processing: 100,
    completed: 101,
    pendingUserReview: 102,
    cancelled: 103,
    rolledBack: 104
};

RadResponder.activityLogCategories = {

    event: 100,
    custom: 101,
    fieldTeam: 102,
    assignment: 103,
    alert: 104,
    alertHistory: 105,
    mixture: 106,
    analysisRequest: 107,
    nonConformance: 108,
    messageBoard: 109,
    modelRequest: 110,
    import: 111,
}


RadResponder.NonConformanceStatuses = {
    created: 100,
    awaitingReview: 101,
    resolved: 102
};

RadResponder.moreInfoMessages = {
    equipmentEfficiency: "Efficiency for the survey is pulled from the selected probe and if no probe is selected or the probe does not have an efficiency value it will be pulled from the selected meter.  You can click on the meter or probe to navigate to them directly."
};

RadResponder.analyticalResultDataPointTypes = [
    { Name: "Samples", Value: RadResponder.dataPointTypes.sample },
    { Name: "Spectra", Value: RadResponder.dataPointTypes.spectra }
];

RadResponder.chemicalAnalyticalResultDataPointTypes = [
    { Name: "Chemical Samples", Value: RadResponder.dataPointTypes.chemicalSample }
];

RadResponder.chemicalAnalyticalResultUnitTypes = {
    volume: 1,
    weight: 2
};



RadResponder.supportsSeverity = function (id) {
    var permittedDataPointTypes = [
        RadResponder.dataPointTypes.survey,
        RadResponder.dataPointTypes.fixedPointSurvey,
        RadResponder.dataPointTypes.accumulatedDose,
        RadResponder.dataPointTypes.aerialReading,
        RadResponder.dataPointTypes.chemicalId,
        RadResponder.dataPointTypes.chemicalReading,
        RadResponder.dataPointTypes.sitrep,
        RadResponder.dataPointTypes.fixedChemicalReading,
        RadResponder.dataPointTypes.concentrationResult,
        RadResponder.dataPointTypes.fieldScreening,
        RadResponder.dataPointTypes.aerialSurvey
    ];
    return permittedDataPointTypes.indexOf(id) > -1;
};
RadResponder.supportsBackground = function (id) {
    return id === RadResponder.dataPointTypes.survey || id === RadResponder.dataPointTypes.sample || id === RadResponder.dataPointTypes.spectra;
};

//https://gist.github.com/gordonbrander/2230317
RadResponder.uniqueId = function () {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return '_' + Math.random().toString(36).substr(2, 9);
};

RadResponder.showValidationErrorsInConsole = function (vm) {
    for (var propName in vm) {
        if (vm.hasOwnProperty(propName)) {
            if (vm[propName] && vm[propName].isValid && !vm[propName].isValid()) {
                console.log(propName, vm[propName].isValid());
            }
        }
    }
};

RadResponder.sampleStatus = {
    collected: 100,
    hold: 101,
    sentToLab: 102,
    disposed: 105,
    sentToStorage: 106,
    notUsable: 107,
    received: 109,
    returned: 110
};

RadResponder.analysisRequestStatus = {
    created: 1,
    senttoLaboratory: 2,
    receivedbyLaboratory: 3,
    resultReceived: 4,
    awaitingReply: 5,
    hold: 6,
    unreviewedResults: 7,
    resultsReviewed: 8,
    notUseable: 9,
    completed: 10
};


RadResponder.participantTypes = {
    fullParticipant: 100,
    viewOnly: 101,
    viewOnlyApproved: 102,
    laboratory: 103,
    eventSponsor: 104,
};

RadResponder.getParticipantTypeNameFromId = function (id) {
    switch (id) {
        case 100:
        case "100":
            return "Full Participant";
        case 101:
        case "101":
            return "View Only";
        case 102:
        case "102":
            return "View Only Approved Data";
        case 103:
        case "103":
            return "Laboratory";
        case 104:
        case "104":
            return "Event Sponsor";
    }
};

RadResponder.sharingModes = {
    networkWide: 1,
    partnersOnly: 2,
    private: 3,
    myOrganizationOnly: 4
};

RadResponder.assessmentStatusEnum = {
    NotAnalyzed: 1,
    Accepted: 4,
    Rejected: 5,
    Suspect: 100
}

RadResponder.systemRoles = {
    siteAdministrator: 100,
    emergencyModeUser: 101,
    staffordActAdministrator: 102,
    accountManager: 103,
    supportManager: 104,
    contentManager: 105
};

RadResponder.eventRoles = {
    eventManager: 100,
    teamManager: 101,
    dataViewer: 102,
    dataCollector: 103,
    dataAssessor: 104,
    approvedDataOnlyDataViewer: 105,
    dosimetryManager: 106,
    dosimetryViewer: 107
};

RadResponder.shareableDataTypes = {
    events: 1,
    facilities: 2,
    dataFeeds: 3,
    equipment: 4,
    sitreps: 5,
    lessonsLearned: 6,
    bioSitreps: 7,
    assessment: 8
};

RadResponder.uploadTypes = {
    documentLibrary: 100,
    photoLibrary: 101,
    spectraDataFile: 102,
    spectraConfigurationFile: 103,
    equipmentMaintenance: 104,
    imports: 105,
    eventDocuments: 106,
    eventSimulation: 107,
    gisFiles: 108,
    dataPointAttachment: 109
};

RadResponder.maintenanceScheduleTypes = {
    none: 100,
    weekly: 101,
    monthly: 102,
    quarterly: 103,
    semiAnually: 104,
    anually: 105,
    biAnually: 106,
    custom: 107,
    every2Weeks: 108
}

RadResponder.maintenanceStatuses = {
    notApplicable: 100,
    fullyMaintained: 101,
    comingDue30: 102,
    comingDue7: 103,
    overdue: 104
}

RadResponder.hazardTypes = {
    radiological: 100,
    chemical: 101,
    biological: 102,
    nuclear: 103,
    explosives: 104
};

RadResponder.getHazardTypeNameFromId = function (id) {
    switch (id) {
        case 100:
        case "100":
            return "Radiological";
        case 101:
        case "101":
            return "Chemical";
        case 102:
        case "102":
            return "Biological";
        case 103:
        case "103":
            return "Nuclear";
    }
};

RadResponder.facilityTypes = {
    npp: 100,
    crc: 101,
    chemicalStorage: 108,
    bioTestingSite: 111
};

RadResponder.screenedPopulationClassification = {
    people: 100,
    animals: 101,
    vehicles: 102
};

RadResponder.screenedPopulationCharacteristics = {
    peopleTotal: 100,
    animalsTotal: 200,
    vehiclesTotal: 300
};

RadResponder.documentDirectoryTypes = {
    root: 100,
    standard: 101,
    eventGisFiles: 102,
};

RadResponder.documentDirectorySubTypes = {

    userUploaded: 100,
    system: 101,
    narac: 102,
    imaac: 103,
};

RadResponder.modelStatus = {
    unpublishedWorkingModel: 100,
    published: 102,
    archived: 103
};

RadResponder.modelRequestStatus = {
    pending: 100,
    accepted: 101,
    rejected: 102,
    closed: 103,
};

RadResponder.modelRequestType = {
    exercise: 100,
    realWorldIncident: 101,
};

RadResponder.criticalLevelType = {
    sensitivity: 1,
    countTime: 2
};

RadResponder.criticalLevelTypes = [
    { Name: "Sensitivity", Value: RadResponder.criticalLevelType.sensitivity },
    { Name: "Count Time", Value: RadResponder.criticalLevelType.countTime }
];

RadResponder.barcodeType = {
    PDF417: 1024,
    CODE39: 4
};

RadResponder.barcodeTypes = [
    { Name: "PDF417", Value: RadResponder.barcodeType.PDF417 },
    { Name: "CODE39", Value: RadResponder.barcodeType.CODE39 }
];

RadResponder.mobileSurveyTypes = {
    aerial: 100,
    driving: 101,
    walking: 102
};

RadResponder.equipmentEfficiencySources = {
    eventDefault: 100,
    equipmentDefault: 101,
    eventEquipmentOverride: 102
};

RadResponder.radSpectrumSources = {
    fieldCollected: 100,
    ims: 101,
    ecam: 102
};

RadResponder.radSpectrumTypes = {
    qualitative: 100,
    quantitative: 101
};

RadResponder.radSpectrumStatuses = {
    collected: 100,
    pendingAnalysis: 101,
    analyzed: 102
};

RadResponder.notificationClass = {
    error: 100,
    warning: 101,
    info: 102,
    success: 103
};

RadResponder.notificationType = {
    all: 100,
    user: 101,
    event: 102,
    organization: 103,
    record: 104
};

RadResponder.personnelSavedConfigurationSharingModes = {
    notShared: 100,
    eventOneOnEvent: 101,
    justMyOrganization: 102,
    specificPeople: 103
};

RadResponder.escalatingEventTypes = {
    specialEvent: 5,
    nonEmergencyOperation: 6
};

RadResponder.emergencyEventTypes = {
    emergencyResponse: 3,
    nonEmergencyOperation: 6
};

RadResponder.dashboardTypes = {
    event: 1,
    organization: 2
}

RadResponder.boolOptions = {
    all: 1,
    yes: 2,
    no: 3
}

RadResponder.externalNotificationType = {
    equipmentMaintenanceWeekly: 256,
    equipmentMaintenanceDueToday: 257
}

RadResponder.geometryTypes = {
    kml: 100,
    shapeFile: 101,
};

RadResponder.geometrySources = {
    naracUpload: 100,
    userUpload: 101,
    system: 102,
    dtraUpload: 103,
    imaacUpload: 104,
    equipmentUpload: 105,
    simulationUpload: 106,
    organization: 107
};

RadResponder.eventSimulationTypes = {
    legacySimulation: 100,
    fromTemplate: 101,
    fromSourceFiles: 102,
    fromExisting: 103
};

RadResponder.eventSimulationSourceTypes = {
    NARAC: 100,
    RASCAL: 101,
    Hotspot: 102
};

RadResponder.eventSimulationDecayMethods = {
    distinctTimeBasedFiles: 100,
    mixtureDecay: 101
};

RadResponder.decayEquationTypes = {
    polynomial: 100,
    exponential: 101,
    timeBasedValues: 102
};

RadResponder.mfaTypes = {
    email: 100,
    sms: 101,
    voice: 102,
    authenticator: 103
};

RadResponder.standardizationTypes = {
    assessment: "Assessment",
    monitoring: "Monitoring",
    standardInternational: "Standard International"
};

RadResponder.statusTypes = {
    active: 1,
    inactive: 2
};

RadResponder.imaacFouoMessage = "All IMAAC models regardless of their status of unpublished working model, published model, or archived model, are <span class=\"bold\">For Official Use Only</span> and should be safeguarded, unless otherwise indicated.";
RadResponder.imaacDownloadMessage = "This product is provided for operational decision support based on the information available. This product and future revisions should not be disseminated further without express permission from the IMAAC Director."

RadResponder.defaultBoolOptions = function (nullText, trueText, falseText) {
    if (!nullText) {
        nullText = "All";
    }
    if (!trueText) {
        trueText = "Yes";
    }
    if (!falseText) {
        falseText = "No";
    }
    return [{ Name: nullText, Value: 1 }, { Name: trueText, Value: 2 }, { Name: falseText, Value: 3 }]
}


RadResponder.getIconForMobileSurveyType = function (mobileSurveyType) {
    switch (mobileSurveyType) {
        case RadResponder.mobileSurveyTypes.aerial:
            return "fa-plane";
        case RadResponder.mobileSurveyTypes.driving:
            return "fa-truck";
        case RadResponder.mobileSurveyTypes.walking:
            return "fa-female";
        default:
            return "fa-plane";
    }
};

RadResponder.isEmpty = function (value) {
    return value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0);
};
RadResponder.isNotEmpty = function (value) {
    return !RadResponder.isEmpty(value);
};
//IE 11 support
RadResponder.isRRR = function (val) {
    if (RadResponder.isNotEmpty(val)) {
        var rrr = _.find(val, function (o) { return o.name == "RadResponderPrepared" })
        if (rrr !== undefined) {
            return rrr.value === "Yes";
        }
    }
    return false;
};
RadResponder.isCRR = function (val) {
    if (RadResponder.isNotEmpty(val)) {
        var crr = _.find(val, function (o) { return o.name == "ChemResponderPrepared" })
        if (crr !== undefined) {
            return crr.value === "Yes"
        }
    }
    return false;
};
RadResponder.isEmptyOrStandardOrg = function (val) {
    if (RadResponder.isEmpty(val)) {
        return true;
    }
    // If the RRR prop exists then CRR must also exist, no need to check for both
    else if (val.length === 2 && _.find(val, function (o) { return o.name == "RadResponderPrepared" }) !== undefined) {
        return true;
    }
    return false;
};
RadResponder.getImagePath = function (path) {
    return RadResponder.getResourceAddress() + "images/" + path;
};

RadResponder.getRRPLogoIconImagePath = function () {
    return RadResponder.getResourceAddress() + "images/custom/logos/rrr/rrp-icon_logo-small.png";
},

RadResponder.getCRPLogoIconImagePath = function () {
    return RadResponder.getResourceAddress() + "images/custom/logos/crr/crp-icon_logo-small.png";
},

RadResponder.toNonLocalePrecisionWithoutTrailingZeros = function (value, parameterPrecision) {
    var wholeNumber,
        decimal,
        precision = parameterPrecision || 6,
        printableDecimal;

    if (value === null || value === undefined) {
        return value;
    }

    if (typeof (value) !== "number") {
        value = parseFloat(value);
    }
    decimal = value % 1;
    wholeNumber = value - decimal;
    printableDecimal = Math.abs(decimal);

    // decimal toFixed to get rounded decimal, then toPrecision to remove any extraneous zeros
    return wholeNumber + "." + parseFloat(parseFloat(printableDecimal.toFixed(precision)).toPrecision(precision)).toString().replaceAll("0.", "");
};

RadResponder.toPrecisionWithoutTrailingZeros = function (value, parameterPrecision) {
    var wholeNumber,
        decimal,
        precision = parameterPrecision || 6,
        printableDecimal;

    if (value === null || value === undefined) {
        return value;
    }

    if (typeof (value) !== "number") {
        value = parseFloat(value);
    }

    if (value === NaN) {
        return null;
    }

    decimal = value % 1;
    wholeNumber = value - decimal;
    printableDecimal = Math.abs(decimal);

    // decimal toFixed to get rounded decimal, then toPrecision to remove any extraneous zeros
    return wholeNumber.toLocaleString() + (printableDecimal > 0 ? "." + parseFloat(parseFloat(printableDecimal.toFixed(precision)).toPrecision(precision)).toString().replaceAll("0.", "") : "");
};

RadResponder.toExactPrecision = function (value, parameterPrecision) {
    var wholeNumber,
        decimal,
        precision = parameterPrecision || 2,
        printableDecimal;

    if (value === null || value === undefined) {
        return value;
    }

    if (typeof (value) !== "number") {
        value = parseFloat(value);
    }

    if (value === NaN) {
        return null;
    }

    decimal = value % 1;
    wholeNumber = value - decimal;
    printableDecimal = Math.abs(decimal);

    // decimal toFixed to get rounded decimal, then toPrecision to remove any extraneous zeros
    return wholeNumber.toLocaleString() + ("." + printableDecimal.toFixed(precision).toString().replaceAll("0.", ""));
};

RadResponder.range = function (start, count) {
    if (arguments.length === 1) {
        count = start;
        start = 0;
    }

    var foo = [];
    for (var i = 0; i < count; i++) {
        foo.push(start + i);
    }
    return foo;
};

RadResponder.mergeObjects = function (obj1, obj2) {
    var obj = {};

    for (var x in obj1)
        if (obj1.hasOwnProperty(x))
            obj[x] = obj1[x];

    for (var x in obj2)
        if (obj2.hasOwnProperty(x))
            obj[x] = obj2[x];

    return obj;
};

RadResponder.extractError = function (jqXhr, textStatus, errorThrown) {
    return RadResponder.extractMessage(jqXhr, textStatus, errorThrown, "The request failed with the following message: ");
};

RadResponder.extractMessage = function (jqXhr, textStatus, errorThrown, baseMessage) {
    var message = baseMessage || "";
    if (jqXhr && jqXhr.responseText) {
        var error = JSON.parse(jqXhr.responseText);
        message += error && error.Message ? error.Message : error;
    }
    else {
        message += (errorThrown ? errorThrown : "Unknown error");
    }

    return message;
};

RadResponder.fileDownloadFailed = function (customMessage) {
    toastr.error("File failed to download.");
};

RadResponder.fileDownloadFailedError = function (e) {
    toastr.error((e.responseJSON || {}).Message || "An error has occured", "File Download Failed");
};

var formatKeys = function (options) {
    var toFill = {};
    for (var i in options) {
        var option = options[i];
        toFill[option.key] = option.val;
    }
    return toFill;
}
// Expand this if necessary.
RadResponder.dataPointTypeLinkFormats = formatKeys([
    { key: RadResponder.dataPointTypes.mixture, val: '#event/{0}/mixtures/details/{1}' },
    { key: RadResponder.dataPointTypes.analysisRequest, val: '#event/{0}/analysisrequests/details/{1}' },
    { key: RadResponder.dataPointTypes.fieldTeam, val: '#event/{0}/teams/details/{1}' },
    { key: RadResponder.dataPointTypes.imaacModelRequest, val: '#imaac/modelrequest/details/{1}' },
    { key: RadResponder.dataPointTypes.alertDefinition, val: '#event/{0}/alerting/definitions/details/{1}' },
    { key: RadResponder.dataPointTypes.alertHistory, val: '#event/{0}/alerting/history/details/{1}' },
    { key: RadResponder.dataPointTypes.messageBoard, val: '#event/{0}/messageboard/details/{1}' },
    { key: RadResponder.dataPointTypes.sample, val: '#event/{0}/samples/details/{1}' },
    { key: RadResponder.dataPointTypes.analyticalResult, val: '#event/{0}/results/details/{1}' },
    { key: RadResponder.dataPointTypes.spectra, val: '#event/{0}/spectras/details/{1}' },
]);

RadResponder.importTypeLinkFormats = formatKeys([
    { key: RadResponder.importTypes.survey, val: '#event/{0}/surveys/import/result/{1}' },
    { key: RadResponder.importTypes.fieldSample, val: '#event/{0}/samples/import/result/{1}' },
    { key: RadResponder.importTypes.analyticalResult, val: '#event/{0}/result/import/result/{1}' },
    { key: RadResponder.importTypes.assignment, val: '#event/{0}/assignments/import/result/{1}' },
    { key: RadResponder.importTypes.analysisRequest, val: '#event/{0}/analysisrequests/import/result/{1}' },
]);

RadResponder.fileDownload = function (url, options) {

    var deferred = $.Deferred();

    var deferredPromise = deferred.promise();
    // Only seeing this as part of covidResponder.  Just being safe in case I missed somewhere it's being used.
    if (typeof options.successCallback === 'function') {
        deferredPromise.done(options.successCallback);
    }
    if (typeof options.failCallback === 'function') {
        deferredPromise.fail(options.failCallback);
    }
    if (typeof options.alwaysCallback === 'function') {
        deferredPromise.always(options.alwaysCallback);
    }

    var filename = null;

    var resp = $.ajax({
        url: url,
        data: options.data,
        // https://stackoverflow.com/questions/50188750/ajax-response-need-to-be-converted-to-blob
        // Setting responseType to blob the other way causes jquery to treat the error text as a blob.
        // https://stackoverflow.com/questions/17657184/using-jquerys-ajax-method-to-retrieve-images-as-a-blob#answer-55120956
        xhr: function () {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 2) {
                    if (xhr.status == 200) {
                        xhr.responseType = "blob";
                    } else {
                        xhr.responseType = "text";
                    }
                }
            };
            return xhr;
        },
        /*xhrFields: {
            responseType: 'blob',
        },*/
        type: options.httpMethod || 'POST',
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        success: function (res, status, xhr) {
            // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Disposition
            var parts = (xhr.getResponseHeader('content-disposition') || '').split(';');
            for (var index in parts) {

                var partParts = parts[index].trim().split('=');

                if (partParts.length === 2 && partParts[0].toLowerCase().trim() === 'filename') {

                    filename = partParts[1].trim();
                    //If a filename contains spaces the filename will be bookend with additional '"' chars
                    //need to remove the bookends '"' or the browser will replace them with underscores
                    if (filename.charAt(filename.length - 1) === '"' && filename.charAt(0) === '"') {
                        //Remove the leading and trailing '"' chars.
                        filename = filename.substr(1, filename.length - 2);
                    }
                    break;
                }
            }
        },
        // done happens after success.  Technically all of it could be done in success, 
        //      but just trying to use the promise lifecycle.
    }).done(function (blob) {
        if (!filename) {

            throw new Error('No filename, probably an error response.');
        }
        // IE11 doesn't allow you to directly open blobs.
        if (typeof (window.navigator || {}).msSaveBlob === 'function') {

            window.navigator.msSaveBlob(blob, filename);
        }
        else {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            // Edge specific issue
            setTimeout(function () {

                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }, 1000);
        }

        deferred.resolve(resp);
    }).fail(function (error) {
        deferred.reject(error);
    });

    return deferredPromise;
}

RadResponder.virtualResourceDownload = function (dataPointTypeId, dataPointId, virtualArguments) {
    return RadResponder.fileDownload(RadResponder.getApiAddress() + 'document/virtual/download', {
        data: {
            dataPointId: dataPointId,
            dataPointTypeId: dataPointTypeId,
            virtualArguments: virtualArguments,
        }
    });
};

RadResponder.intersectionObjects = function () {
    var intersectionObjects2 = function (a, b, areEqualFunction) {
        var results = [];

        for (var i = 0; i < a.length; i++) {
            var aElement = a[i];
            var existsInB = _.any(b, function (bElement) { return areEqualFunction(bElement, aElement); });

            if (existsInB) {
                results.push(aElement);
            }
        }

        return results;
    };

    var results = arguments[0];
    var lastArgument = arguments[arguments.length - 1];
    var arrayCount = arguments.length;
    var areEqualFunction = _.isEqual;

    if (typeof lastArgument === "function") {
        areEqualFunction = lastArgument;
        arrayCount--;
    }

    for (var i = 1; i < arrayCount; i++) {
        var array = arguments[i];
        results = intersectionObjects2(results, array, areEqualFunction);
        if (results.length === 0) break;
    }

    return results;
};


RadResponder.ieVersion = function () {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
    {
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
    }

    return false;
};


/* Hex to RGB conversion:
 * http://www.javascripter.net/faq/hextorgb.htm
 */
var cutHex = function (h) {
    return (h.charAt(0) === "#") ? h.substring(1, 7) : h;
};
var hexToR = function (h) {
    return parseInt((cutHex(h)).substring(0, 2), 16);
};
var hexToG = function (h) {
    return parseInt((cutHex(h)).substring(2, 4), 16);
};
var hexToB = function (h) {
    return parseInt((cutHex(h)).substring(4, 6), 16);
};
//https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color
RadResponder.computeTextColor = function (color, simple) {
    var r = hexToR(color);
    var g = hexToG(color);
    var b = hexToB(color);
    if (simple) {
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#ffffff';
    } // else complex formula
    var uicolors = [r / 255, g / 255, b / 255];
    var c = _.map(uicolors, function (c) {
        if (c <= 0.03928) {
            return c / 12.92;
        } else {
            return Math.pow((c + 0.055) / 1.055, 2.4);
        }
    });

    var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
    return L > 0.179 ? '#000000' : '#ffffff';
};



RadResponder.convertBarSeparateToComma = function (input) {
    return input ? input.split("|").join(", ") : null;
};
RadResponder.convertBarSeparatedToBreakSeparated = function (input) {
    return input ? input.split("|").join("<br />") : null;
};

RadResponder.clone = function (obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = RadResponder.clone(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = RadResponder.clone(obj[attr]);
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
};

RadResponder.cloneObject = function (obj) {
    if (obj === null || typeof obj !== "object") {
        return obj;
    }

    //zz - somehow calling the constructor creates null data for objects, for example the stroke color when used by the kml, i think instead we should just set temp to be an object and copy over the properties
    var temp = obj instanceof Array ? [] : {};//obj.constructor();} // give temp the original obj's constructor
    for (var key in obj) {
        temp[key] = RadResponder.cloneObject(obj[key]);
    }

    return temp;
};

//need static instance of this with debounce so that all usages are debounced together
RadResponder.sendSetting = _.debounce(function (path, data) {
    $.ajax({
        type: "POST",
        url: RadResponder.getApiAddress() + "personnel/savepersonnelsetting",
        data: { key: path, value: data }
    });
}, 1000);

RadResponder.Sessions = function () {
    var self = this;
    self._settingsStorageName = function (path, doNotSendToServer) {
        return document.getElementById("virtualDirectoryPath").value + ";" + self._getPersonId() + ";" + path + (doNotSendToServer ? ";local-only" : "");
    };

    self._sendSetting = RadResponder.sendSetting

    self._getPersonId = function () {
        return document.getElementById("personId").value;
    };

    self.saveSetting = function (path, key, value, doNotSendToServer) {
        //if personId not set, leave
        if (isNaN(parseInt(self._getPersonId()))) {
            return;
        }

        var storageKey = self._settingsStorageName(path, doNotSendToServer);
        var json = window.sessionStorage.getItem(storageKey);
        var obj = {};
        // Somehow gets double wrapped in session.
        try { obj = (json ? JSON.parse(json) || {} : {}); } catch (e) { };
        if (typeof obj === 'string') {
            try { obj = (obj ? JSON.parse(obj) || {} : {}); } catch (e) { };
        }
        obj[key] = value;
        json = JSON.stringify(obj);
        window.sessionStorage.setItem(storageKey, json);

        if (!doNotSendToServer) {
            self._sendSetting(path, json);
        }
    };

    self._fetchSettingObj = function (path, doNotGetFromServer) {
        var json = window.sessionStorage.getItem(self._settingsStorageName(path));

        if (!json && !doNotGetFromServer) {
            $.ajax({
                type: "POST",
                url: RadResponder.getApiAddress() + "personnel/loadpersonnelsetting",
                data: { key: path },
                success: function (data) {
                    json = data;
                },
                dataType: "text",
                async: false
            });

            if (json) {
                window.sessionStorage.setItem(self._settingsStorageName(path), json);
            }
        }

        var obj = {};
        try { obj = (json ? JSON.parse(json) || {} : {}); } catch (e) { };
        if (typeof obj === 'string') {
            try { obj = (obj ? JSON.parse(obj) || {} : {}); } catch (e) { };
        }
        return obj;
    };

    self.loadSetting = function (path, key, doNotGetFromServer) {
        var obj = self._fetchSettingObj(path, doNotGetFromServer);
        return obj[key];
    };

    self.hasSetting = function (path, key) {
        var obj = self._fetchSettingObj(path);
        return obj.hasOwnProperty(key);
    };

    self.getSettingsPath = function (router) {
        return router.activeInstruction().fragment;
    };

    self.saveDataTableSettings = function (path, key) {
        return function (oSettings, oData) { self.saveSetting(path, key, oData); };
    };

    self.loadDataTableSettings = function (path, key) {
        return function (oSettings) { return self.loadSetting(path, key); };
    };

    var dataTableConfigurationKey = "settings";
    self.saveDataTableConfiguration = function (path, data) {
        self.saveSetting(path + '#config', dataTableConfigurationKey, data);
    };

    self.loadDataTableConfiguration = function (path) {
        return self.loadSetting(path + '#config', dataTableConfigurationKey);
    };
    return self;
};

RadResponder.getExtensionFromFileName = function (fileName) {
    if (fileName) {
        var fileNameParts = fileName.split(".");
        return fileNameParts[fileNameParts.length - 1];
    }
};

RadResponder.getFontAwesomeIconForFileExtension = function (fileExtension) {
    if (fileExtension) {
        if (fileExtension.toLowerCase() == "pdf") {
            return "fa fa-solid fa-file-pdf bigger-400";
        } else if (fileExtension.toLowerCase() == "txt") {
            return "fa fa-solid fa-file-lines bigger-400";
        } else if (fileExtension.toLowerCase() == "doc" || fileExtension.toLowerCase() == "docx") {
            return "fa fa-solid fa-file-word bigger-400";
        } else if (fileExtension.toLowerCase() == "xls" || fileExtension.toLowerCase() == "xlsx") {
            return "fa fa-solid fa-file-excel bigger-400";
        } else if (fileExtension.toLowerCase() == "ppt" || fileExtension.toLowerCase() == "pptx") {
            return "fa fa-solid fa-file-powerpoint bigger-400";
        } else if (fileExtension.toLowerCase() == "html" || fileExtension.toLowerCase() == "cs" || fileExtension.toLowerCase() == "js") {
            return "fa fa-regular fa-file-code bigger-400";
        } else if (fileExtension.toLowerCase() == "zip" || fileExtension.toLowerCase() == "7z" || fileExtension.toLowerCase() == "rar") {
            return "fa fa-solid fa-file-zipper bigger-400";
        } else {
            return "fa fa-solid fa-file bigger-400";
        }
    }

    return null;
};

RadResponder.isImage = function (filename) {
    var ext = getExtension(filename);
    switch (ext.toLowerCase()) {
        case "jpg":
        case "jpeg":
        case "gif":
        case "bmp":
        case "png":
            //etc
            return true;
    }
    return false;
};

var getExtension = function (filename) {
    var parts = filename.split(".");
    return parts[parts.length - 1];
};

RadResponder.isExtension = function (filename, ext) {
    return ext.toLowerCase() === (getExtension(filename)).toLowerCase();
};

RadResponder.isAcceptedFileType = function (filename, extensions) {
    var ext = getExtension(filename);
    return !extensions || extensions.length === 0 || _.some(extensions, function (e) { return ext.toLowerCase() === e.toLowerCase(); });
};

RadResponder.createPasswordRequirementsFromSecurityConfig = function (securityConfig) {
    var result = "";

    result += String.format("<span>Passwords must contain at least {0} characters, including:</span>\n", securityConfig.Password_Minimum_Length);
    result += "<ul>\n";
    result += String.format("     <li>A minimum of {0} lowercase character(s)</li>", securityConfig.Password_Lowercase_Requirement);

    if (securityConfig.Password_Uppercase_Requirement) {
        result += String.format("     <li>A minimum of {0} uppercase character(s)</li>", securityConfig.Password_Uppercase_Requirement);
    }

    if (securityConfig.Password_Numeric_Requirement) {
        result += String.format("     <li>A minimum of {0} numeric character(s)</li>", securityConfig.Password_Numeric_Requirement);
    }

    if (securityConfig.Password_NonAlphaNumeric_Requirement) {
        result += String.format("     <li>A minimum of {0} special character(s)</li>", securityConfig.Password_NonAlphaNumeric_Requirement);
    }

    result += "</ul>\n";

    if (securityConfig.Password_Reuse_Limit) {
        result += String.format("<span>You cannot reuse your previous {0} passwords.</li>", securityConfig.Password_Reuse_Limit);
    }

    return result;
};
RadResponder.createUsernameRequirementsFromSecurityConfig = function (securityConfig) {
    return String.format("<span>Usernames must contain between {0}-{1} characters. Shared account usernames must be at least one character.</span>\n", securityConfig.Username_Minimum_Length, securityConfig.Username_Maximum_Length);
};



RadResponder.defaultAutoCompleteSettings = {
    type: "POST",
    dataType: "json",
    delay: 250,
    data: function (params) {
        return {
            query: params.term
        };
    },
    processResults: function (data, params) {
        return {
            results: _.map(data, function (p) { return { text: p.Name, id: p.Value, type: p.Type } })
        };
    }
};

RadResponder.mergeWithDefaultAutoCompleteSettings = function (settings) {
    return $.extend({}, RadResponder.defaultAutoCompleteSettings, settings);
};

RadResponder.getChemicalAutoCompleteSettings = function (options) {
    options = options || {};
    return RadResponder.mergeWithDefaultAutoCompleteSettings({
        url: RadResponder.getApiAddress() + "chemical/autocomplete",
        data: function (params) {
            return {
                query: params.term,
                eventId: options.eventId,
                organizationId: options.organizationId
            };
        },
        processResults: function (data) {
            return {
                results: _.map(data, function (p) {
                    return {
                        text: p.Display_Name,
                        id: p.Chemical_Id,
                        description: p.Description
                    }
                })
            };
        }
    });
}


RadResponder.waitToComplete = function (promise, done, fail, always) {
    var deferred = $.Deferred();

    promise.done(function (data) {
        if (done) {
            done(data);
        }
        deferred.resolve(true);
    })
        .fail(function (jqXhr, textStatus, errorThrown) {
            if (fail) {
                fail(jqXhr, textStatus, errorThrown);
            }
            deferred.resolve(false);
        })
        .always(function () {
            if (always) {
                always();
            }
        });

    return deferred.promise();
};



//sort dashboard tiles by position
RadResponder.sortTilesByPosition = function (a, b) {
    if (a.PositionY() === b.PositionY()) {
        if (a.PositionX() === b.PositionX())
            return b.TileId - a.TileId;
        else return a.PositionX() - b.PositionX();
    }
    return a.PositionY() - b.PositionY();
};


RadResponder.setCaretAtEnd = function (elem) {
    if (!elem.value)
        return;
    var elemLen = elem.value.length;
    // For IE Only
    if (document.selection) {
        // Set focus
        elem.focus();
        // Use IE Ranges
        var oSel = document.selection.createRange();
        // Reset position to 0 & then set at end
        oSel.moveStart("character", -elemLen);
        oSel.moveStart("character", elemLen);
        oSel.moveEnd("character", 0);
        oSel.select();
    } else if (elem.selectionStart || elem.selectionStart === 0) {
        // Firefox/Chrome
        elem.selectionStart = elemLen;
        elem.selectionEnd = elemLen;
        elem.focus();
    }
};

RadResponder.goToSignedOutPage = function () {
    var signedOutPath = "/app/signedout";
    if (location.pathName !== signedOutPath) {
        location.href = [location.protocol, '//', location.host, signedOutPath, "?returnUrl=", location.hash.substring(1)].join('');
    }
};



//--------------------------------------------------------
// SignalR Notifications
//--------------------------------------------------------
RadResponder.SignalR = RadResponder.SignalR || {};
RadResponder.SignalR.attemptReconnect = true;
RadResponder.SignalR.hub = null;
RadResponder.SignalR.initialize = function () {
    if (RadResponder.SignalR.hub) {
        RadResponder.SignalR.attemptReconnect = false;
        if (RadResponder.SignalR.hub.stop) {
            RadResponder.SignalR.hub.stop();
        }
        RadResponder.SignalR.hub = null;
    }

    //set up signalR listener
    var hub = $.connection.notificationHub;
    RadResponder.SignalR.hub = hub;
    RadResponder.SignalR.attemptReconnect = true;
    hub.client.broadcastNotification = RadResponder.SignalR.broadcastNotification;
    hub.client.broadcastDiagnosticMessage = RadResponder.SignalR.broadcastDiagnosticMessage;
    hub.client.broadcastToastr = RadResponder.SignalR.broadcastToastr;
    hub.client.broadcastUserSessionRedirectToSignedOut = RadResponder.SignalR.broadcastUserSessionRedirectToSignedOut;
    $.connection.hub.logging = true;
    $.connection.hub.start();

    //set up method to try to reconnect after a disconnect
    $.connection.hub.disconnected(function () {
        if (!RadResponder.SignalR.attemptReconnect) {
            return;
        }

        setTimeout(function () {
            $.connection.hub.start();
        }, 5000); // Restart connection after 5 seconds.
    });
};

RadResponder.SignalR.subscribeToChatStatusChanges = function (action) {
    RadResponder.SignalR.hub.on("broadcastChatStatusChanged", function (personnelId) {
        action(personnelId);
    });
};

RadResponder.SignalR.broadcastNotification = function (notification) {
    var excludeView = _.some(notification.ExcludeView, function (view) {
        return window.location.href.indexOf(view) > -1;
    });
    if (excludeView) {
        return;
    }

    if (!RadResponder.isEmpty(notification.IncludeView)) {
        var includeView = _.some(notification.IncludeView, function (view) {
            return window.location.href.indexOf(view) > -1;
        });
        if (!includeView) {
            return;
        }
    }

    RadResponder.SignalR.showNotification(notification);
};

RadResponder.SignalR.showNotification = function (notification, actions) {
    var notificationContainer = $(".notification-container");
    var $notification = RadResponder.SignalR.createNotification(notification, actions);
    if (!notification.NoFadeIn) {
        $notification = $notification.fadeIn(800, function () {
            var self = this;

            //add timeout if one is specified
            if (notification.Timeout) {
                setTimeout(function () {
                    $(self).fadeOut(750, function () {
                        $(self).alert("close");
                    });
                }, notification.Timeout);
            }

        })
    }
    notificationContainer.append($notification);
    RadResponder.SignalR.updateShellPosition(notificationContainer);
};

RadResponder.SignalR.broadcastDiagnosticMessage = function (message) {
    console.log("(diagnostic message - " + moment().format("MM/DD/YYYY HH:mm:ss") + "): " + message);
};

RadResponder.SignalR.broadcastUserSessionRedirectToSignedOut = function (obj) {
    var sessionId = document.getElementById("sessionId").value;

    if (!!obj.sessionId && sessionId.toString() === obj.sessionId.toString()) {
        RadResponder.goToSignedOutPage();
    }
};

RadResponder.SignalR.unregisterForBroadcastUserSessionRedirectToSignedOut = function () {
    //clear event handler for sign out redirects
    // -- we do this when the current tab is the one initiating the sign out.
    // -- this tab will be sent to the identity server to logout, so we don't want this tab to redirect to the signedOut page
    // -- changing to a backchannel logout may allow this to be removed
    RadResponder.SignalR.hub.client.broadcastUserSessionRedirectToSignedOut = null;
};

RadResponder.SignalR.broadcastToastr = function (notification) {
    if (toastr) {
        switch (notification.NotificationClass) {
            case RadResponder.notificationClass.error:
                toastr.error(notification.Message, notification.Title, { hideDuration: notification.Timeout });
                return;
            case RadResponder.notificationClass.warning:
                toastr.warning(notification.Message, notification.Title, { hideDuration: notification.Timeout });
                return;
            case RadResponder.notificationClass.info:
                toastr.info(notification.Message, notification.Title, { hideDuration: notification.Timeout });
                return;
            case RadResponder.notificationClass.success:
                toastr.success(notification.Message, notification.Title, { hideDuration: notification.Timeout });
                return;
        }
    }
};


RadResponder.SignalR.registerForBulkRecordUpdates = function (id, dataPointTypeId, action) {
    if (!RadResponder.SignalR.hub) {
        throw "No SignalR connection found";
    }

    RadResponder.SignalR.hub.on("updateBulkRecords", function (data) {
        if (!data || data.DataPointTypeId !== dataPointTypeId || !data.DataPoints || !data.DataPoints.length || data.DataPoints.indexOf(parseInt(id)) < 0) {
            return;
        }

        action();
    });
};

RadResponder.SignalR.unregisterForBulkRecordUpdates = function () {
    if (!RadResponder.SignalR.hub) {
        throw "No SignalR connection found";
    }

    RadResponder.SignalR.hub.off("updateBulkRecords");
};


RadResponder.SignalR.registerForEventDataPointUpdates = function (id, dataPointTypeId, action, selectedEvents) {
    if (!RadResponder.SignalR.hub) {
        throw "No SignalR connection found";
    }

    RadResponder.SignalR.hub.on("updateBulkRecords", _.throttle(function (data) {
        if (!data || data.DataPointTypeId !== dataPointTypeId || !data.Events || !data.Events.length || (data.Events.indexOf(parseInt(id)) < 0 && id !== "live") || (id === "live" && !_.intersection(data.Events, selectedEvents).length)) {
            return;
        }

        action(data);
    }), 60000);
};

RadResponder.SignalR.unregisterForEventDataPointUpdates = RadResponder.SignalR.unregisterForBulkRecordUpdates;

var refreshListShown = false;
RadResponder.SignalR.registerForListRefreshUpdates = function (id, dataPointTypeId, selectedEvents, action, disableAutoRefresh) {
    var refreshDelay = 10000; // Milliseconds

    var wrappedAction = function (data) {
        if (refreshListShown) {
            return;
        }
        refreshListShown = true;
        var notification = {
            NotificationClass: RadResponder.notificationClass.info,
            NotificationType: RadResponder.notificationType.user,
            Timestamp: new Date(),
            Title: "Pending List Refresh",
            Message: "The data for this list has changed. The list will update in ten seconds.",
            Timeout: refreshDelay
        };

        var skipRefresh = false;

        var actions = [
            {
                Text: "Skip Refresh",
                Action: function () {
                    skipRefresh = true;
                }
            },
            {
                Text: "Disable Auto-Refresh",
                Action: function () {
                    disableAutoRefresh();
                    skipRefresh = true;
                }
            }
        ];

        RadResponder.SignalR.showNotification(notification, actions);

        setTimeout(function () {
            if (!skipRefresh) {
                action(data);
            }
            else {
                skipRefresh = false;
            }
            refreshListShown = false;
        }, refreshDelay);
    };

    return RadResponder.SignalR.registerForEventDataPointUpdates(id, dataPointTypeId, wrappedAction, selectedEvents);
};


RadResponder.SignalR.registerForEventUpdates = function (action) {
    if (!RadResponder.SignalR.hub) {
        throw "No SignalR connection found";
    }

    RadResponder.SignalR.hub.on("eventsChanged", function (data) {
        if (action) {
            action(data);
        }
    });
};

RadResponder.SignalR.unregisterForEventUpdates = function () {
    if (!RadResponder.SignalR.hub) {
        throw "No SignalR connection found";
    }

    RadResponder.SignalR.hub.off("eventsChanged");
};


RadResponder.SignalR.registerForNewEventData = function (action) {
    if (!RadResponder.SignalR.hub) {
        throw "No SignalR connection found";
    }

    RadResponder.SignalR.hub.on("newDataAvailable", function (data) {
        action(data);
    });
};

RadResponder.SignalR.unregisterForNewEventData = function () {
    if (!RadResponder.SignalR.hub) {
        throw "No SignalR connection found";
    }

    RadResponder.SignalR.hub.off("newDataAvailable");
};


RadResponder.SignalR.registerForNewPersonnelData = function (action) {
    if (!RadResponder.SignalR.hub) {
        throw "No SignalR connection found";
    }

    RadResponder.SignalR.hub.on("personnelDataChanged", function (data) {
        RadResponder.SignalR.broadcastNotification(data);
        var openedChats = $('.close-channel');
        if (openedChats && openedChats.length > 0) {
            $.each(openedChats,
                function (idx, n) {
                    if (n.click) {
                        n.click();
                    }
                });
        }
        if (action) {
            action();
        }
    });
};

RadResponder.SignalR.unregisterForNewPersonnelData = function () {
    if (!RadResponder.SignalR.hub) {
        return;
    }

    RadResponder.SignalR.hub.off("personnelDataChanged");
};

RadResponder.SignalR.registerForOrganizationPartnershipUpdate = function (action) {
    if (!RadResponder.SignalR.hub) {
        return;
    }

    RadResponder.SignalR.hub.on("organizationPartnershipUpdated", function (data) {
        if (action) {
            action(data);
        }
    });
};

RadResponder.SignalR.unregisterForOrganizationPartnershipUpdate = function () {
    if (!RadResponder.SignalR.hub) {
        return;
    }

    RadResponder.SignalR.hub.off("organizationPartnershipUpdated");
};


RadResponder.SignalR.updateShellPosition = function (notificationContainer) { };

RadResponder.SignalR.createNotification = function (notification, actions) {
    var container = $('<div class="alert ' + RadResponder.SignalR.getNotificationClass(notification.NotificationClass) + (notification.AdditionalClasses ? ' ' + notification.AdditionalClasses : '') + ' alert-dismissible alert-nobottommargin alert-square" role="alert" />');
    var fadeContainer = function (fadeOutMs) {
        container.fadeOut(fadeOutMs || 750, function () {
            container.alert("close");
        });
    }
    //append close button
    container.append($('<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>'));

    //append title
    if (notification.Title) {
        container.append($('<strong class="right5">' + notification.Title + "</strong>"));
    }

    container.append(notification.Message);

    if (actions && actions.length) {
        $.each(actions, function (i, action) {
            container.append($('<button type="button" class="btn btn-xs ' + (action.BtnClass ? action.BtnClass : 'btn-primary') + ' left5' + (action.AdditionalClasses ? ' ' + action.AdditionalClasses : '') + ' right5"></button>').text(action.Text).on('click', function () {
                action.Action();
                if (!action.DontFadeOnClick) {

                    fadeContainer();
                }
            }));
        });
    }

    container.on('click', 'a.notification-click-fade', function () {
        if (typeof notification.HideAction === 'function') {
            notification.HideAction();
        }
        else {
            // 2s delay before it starts to fade.  Allows normal action.
            setTimeout(function () {
                fadeContainer();
            }, 2000);
        }
    });

    var itemWithClick = container.find("a[data-click]");
    var clickHandler = itemWithClick.attr("data-click");
    // add this data attr to notification class if it shouldn't remove notification post click.
    var shouldntClearAfterClick = (!!itemWithClick.attr('data-dont-close-click')) || notification.DontCloseOnClick || false;
    var href = itemWithClick.attr("href");
    itemWithClick.click(function (e) {
        RadResponder[clickHandler](href);
        if (!shouldntClearAfterClick) {
            container.fadeOut(750, function () {
                container.alert("close");
            });
        }
        return false;
    });

    if (!notification.NoFadeIn) {

        container.hide();
    }

    container.on("closed.bs.alert", function () {
        RadResponder.SignalR.updateShellPosition($(".notification-container"));
    });

    return container;
};

RadResponder.SignalR.getNotificationClass = function (type) {
    switch (type) {
        case RadResponder.notificationClass.error:
            return "alert-danger";
        case RadResponder.notificationClass.warning:
            return "alert-warning";
        case RadResponder.notificationClass.info:
            return "alert-info";
        case RadResponder.notificationClass.success:
            return "alert-success";
    }
};


RadResponder.SignalR.registerForStatusUpdates = function (action) {
    if (!RadResponder.SignalR.hub) {
        throw "No SignalR connection found";
    }

    RadResponder.SignalR.hub.on("updateStatus", function (data) {
        action(data);
    });
};

RadResponder.SignalR.unregisterForStatusUpdates = function () {
    if (!RadResponder.SignalR.hub) {
        throw "No SignalR connection found";
    }

    RadResponder.SignalR.hub.off("updateStatus");
};




RadResponder.setupKnockoutValidation = function () {
    //--------------------------------------------------------
    // Setup validation defaults
    //--------------------------------------------------------
    ko.validation.init({
        insertMessages: true,
        decorateInputElement: true,
        errorClass: "has-error",
        errorElementClass: "has-error",
        errorsAsTitle: false,
        grouping: {
            deep: true,
            live: true,
            observable: true
        }
    });
    ko.validation.registerExtenders();

    //--------------------------------------------------------
    // Override Some ko.validation functions for accessibility
    //--------------------------------------------------------
    ko.validation.insertValidationMessage = (function () {
        var originalInsertValidationMessage = ko.validation.insertValidationMessage;
        return function (element) {
            var span = originalInsertValidationMessage(element);

            //add unique id to error mesasge
            var $span = $(span);
            $span.uniqueId();

            //add described by to element
            $(element).attr({ "aria-describedby": $span.attr("id") });

            //move to the end of the parent
            var $parent = $span.parent();
            $span.appendTo($parent);

            return span;
        };
    })();



    //Fix number rule to disallow comma separation
    ko.validation.rules['number'] = {
        validator: function (value, validate) {
            if (!validate) { return true; }
            return ko.validation.utils.isEmptyVal(value) || (validate && /^(?:-\d+)?(?:\d+)?(?:\.\d+)?$/.test(value));
        },
        message: 'Please enter a number.'
    };
    //--------------------------------------------------------
    // Add additional binding handlers to ko validation
    //--------------------------------------------------------
    ko.validation.makeBindingHandlerValidatable("select2Value");
    ko.validation.makeBindingHandlerValidatable("datetimepicker");
    ko.validation.makeBindingHandlerValidatable("tzdatetimepicker");
    ko.validation.makeBindingHandlerValidatable("valueWithCommaSupport");
};


//--------------------------------------------------------
// Add some app defaults
//--------------------------------------------------------
$(function () {
    //set up prefilter for CSRF using meta tag injected in MVC page, App/Index
    RadResponder.setCsrfToken($(RadResponder.csrfTokenMetaTagSelector).attr("content"));

    //add window resize event to update notification-container sizing
    window.addEventListener("resize", function (event) {
        RadResponder.SignalR.updateShellPosition($(".notification-container"));
    });

    //set up AJAX handlers
    $(document)
        .ajaxError(function (event, jqXhr, ajaxSettings, thrownError) {
            var unauthorizedPage = "/errors/unauthorized";

            //if the user's session expired, reload to get to the login page
            if (jqXhr.status === 500 && jqXhr.responseText.match(/The provided anti-forgery token was meant for */)) {
                location.reload(true);
            }
            else if (jqXhr.status === 500 && jqXhr.responseJSON && jqXhr.responseJSON.Message && jqXhr.responseJSON.Message.indexOf("The request timed out.") >= 0) {
                toastr.error(jqXhr.responseJSON.Message, "Request Timed Out", { timeOut: 10000 });
                return;
            }
            else if (
                jqXhr.status === 401
                && event
                && event.currentTarget
                && event.currentTarget.URL.match(/#event\/([0-9]+|live)\/map/)
                && jqXhr.statusText !== "abort" //not an abort from the autocomplete controls -- expected
                && (
                    !ajaxSettings
                    || !ajaxSettings.url
                    || (
                        ajaxSettings.url !== "/api/v2/web/uploadedgeometry/uploadkmlfile" //don't use this handler for geometry uploads
                        && ajaxSettings.url !== "/api/v2/web/uploadedgeometry/uploadshapefile" //don't use this handler for geometry uploads
                        && ajaxSettings.url !== "/api/v2/web/chemical/autocomplete" //don't use this handler for chemical autocomplete requests
                        && ajaxSettings.url !== "/api/v2/web/userdrawing/create" //don't use this handler for errors when attempting to save a user drawing.
                        && ajaxSettings.url !== "/api/v2/web/userdrawing/edit" //don't use this handler for errors when attempting to save a user drawing.
                        && ajaxSettings.url !== "/api/v2/web/eventmap/getclusterlist" //don't use this handler for errors when attempting fetch clusters. errors are expected on cache timeout.
                        && ajaxSettings.url !== '/api/v2/web/eventmap/downloadshapefile'
                        && ajaxSettings.url !== '/api/v2/web/eventmap/downloadkml'
                        && ajaxSettings.url !== '/api/v2/web/eventsimulation/addsimulationkmltomap'
                    )
                )) {

                //if we have a failure on the map
                // - check to see if a saved config exists
                // - if so, delete it and refresh the map
                var matchedText = event.currentTarget.URL.match(/#event\/([0-9]+|live)\/map/);
                if (!matchedText || matchedText.length === 0) {
                    window.location.href = unauthorizedPage;
                }

                var splitText = matchedText[0].split("/");
                if (!splitText || splitText.length < 2) {
                    window.location.href = unauthorizedPage;
                }

                var eventId = splitText[1];
                if (!eventId) {
                    window.location.href = unauthorizedPage;
                }

                if (eventId === 'live') eventId = "";
                var key = "rr-eventmap-{" + eventId + "}";
                var config = window.localStorage.getItem(key);
                if (!config) {
                    window.location.href = unauthorizedPage;
                }

                window.localStorage.removeItem(key);
                window.localStorage.removeItem(key + "-details");
                window.location.reload();
            }
            else if (
                jqXhr.status === 401
                && (
                    !ajaxSettings
                    || !ajaxSettings.url
                    || (ajaxSettings.url.indexOf("chat/token") === -1 && ajaxSettings.url.indexOf("signalr") === -1)
                )) {
                //accessed a record they don't have access to view.
                window.location.href = "/errors/unauthorized";
            }
            else {
                console.log("AJAX error: " + thrownError + "; Status: " + jqXhr.statusText);
            }
        })
        .ajaxStart(function () {
            RadResponder.Timeout.clearTimer();//clear if there's a timer running so it doesn't expire during call
        })
        .ajaxComplete(function () {
            RadResponder.Timeout?.broadcastNewActivity();
            RadResponder.Timeout.process();
            RadResponder.identityRefresh.refreshIdentityStatus();
        });

    //start site timeout timer
    RadResponder.Timeout.process();
});

RadResponder.identityRefresh = {
    lastIdentityRefresh: null,

    refreshIdentityStatus: function () {
        // If it's been more than a minute since our last refresh
        if (!this.lastIdentityRefresh || (Date.now() - this.lastIdentityRefresh) > 60000) {
            this.lastIdentityRefresh = Date.now();
            $('#idProvIFrame').attr('src', $('#idProvIFrame').attr('src'));
        }
    }
};

//--------------------------------------------------------
// Add USNG support
//--------------------------------------------------------
RadResponder.usng = {
    convertFromLatLong: function (lat, long) {
        if (window.USNG2) {
            return new window.USNG2().fromLonLat({ lon: long, lat: lat });
        }
        if (getUSNG) {
            return getUSNG.calculateUSNG(lat + "," + long);
        }
        return null;
    }
};

RadResponder.parseInt = function (value) {
    // Parse int can be finicky.  
    //      It's "Not reccomended" to send in non strings (including ints).
    //      Some browsers use base8 by default (mainly an issue for ironpdf, or the old version of ironpdf, but still the case in some browsers...)
    // This function standardizes the checks.
    return parseInt('' + value, 10);
}

RadResponder.getEventSponsorLink = function (event, asBlank) {
    var link;
    if (event) {
        var sponsorName;
        if (typeof event.sponsor === 'function') {
            var localSponsorName = event.sponsor();

            if (!RadResponder.isEmpty(localSponsorName)) {
                sponsorName = localSponsorName;
            }
        }
        var sponsorHref;
        if (typeof event.sponsorId === 'function') {
            var sponsorId = RadResponder.parseInt(event.sponsorId());
            if (sponsorId === 0 || sponsorId) {
                sponsorHref = '#network/organizations/details/' + sponsorId;
            }
        }

        if (sponsorName && sponsorHref) {
            link = '<span>(<a href="' + sponsorHref + '"' + (asBlank ? ' target="_blank"' : '') + '>' + sponsorName + '</a>)</span>';
        }
    }
    return link;
}

RadResponder.getDirectoryArguments = function (argument) {

    var folderId = null;
    var virtualArguments = null;

    if (argument) {
        // If no /, then it's a folder id
        if (('' + argument).indexOf('/') === -1) {
            folderId = argument;
        }
        // If a /, it's virtual.
        else {
            virtualArguments = [];

            var splitArgs = ('' + argument).split('/');

            for (var i in splitArgs) {
                // safety check.
                if (!splitArgs.hasOwnProperty(i) || !splitArgs[i] || typeof splitArgs[i] === 'function') {
                    continue;
                }

                var intArg = parseInt('' + splitArgs[i], 10);
                // 0 shouldn't be possible, and non ints shouldn't exist.
                if (intArg) {
                    virtualArguments.push(intArg);
                }
            }
        }
    }

    return {
        folderId: folderId,
        virtualArguments: virtualArguments,
    };
}


RadResponder.geocodeFromAddress = function (cachedMap, address, latitude, longitude, mapApiKey, callback) {
    if (!address) {
        return;
    }

    var map = cachedMap ? cachedMap.map : null;

    if (!map || typeof (map) !== "object") {
        if (mapApiKey) {
            var element = document.createElement("div");
            map = new window.Microsoft.Maps.Map(element,
                {
                    credentials: mapApiKey,
                    customizeOverlays: true,
                    enableSearchLogo: false,
                    showDashboard: true,
                    showScalebar: false,
                    showMapTypeSelector: true,
                    mapTypeId: window.Microsoft.Maps.MapTypeId.road
                });
        } else {
            if (callback) {
                callback(null);
            }
            return;
        }
    }

    var searchManager = new Microsoft.Maps.Search.SearchManager(map);
    var geocodeRequest = {
        where: address,
        count: 5,
        bounds: Microsoft.Maps.LocationRect.fromCorners(new Microsoft.Maps.Location(49.38, -66.94), new Microsoft.Maps.Location(25.82, -124.39)),
        callback: function (response) {
            var success = null;
            try {
                //Match Code Enumeration
                //Name
                //Description
                //none
                //No match was found.
                //good
                //The match was good.
                //ambiguous
                //The match was ambiguous. Multiple results were returned.
                //upHierarchy
                //The match was found by a broader search.
                //modified
                //The match was found, but possibly using a modified query.
                //Match Confidence Enumeration: High, Medium, Low
                $.each(response.results, function (idx, loc) {
                    if (loc.matchConfidence === "High" || loc.matchCode === "Good") {
                        success = loc.location;
                        return false;
                    }
                });
            }
            catch (e) {
                success = null;
            }

            if (success == null) {
                if (typeof (latitude) == "function") {
                    latitude(null);
                    longitude(null);
                }
                if (callback) {
                    callback(null);
                }
                return;
            }
            if (typeof (latitude) === "function") {
                latitude(success.latitude);
                longitude(success.longitude);
                if (callback) {
                    callback(success);
                }
            }
            map.setView({ center: success, zoom: 12 });
        },
        errorCallback: function () {
            if (callback) {
                callback(null);
            }
            return;
        }
    };
    searchManager.geocode(geocodeRequest);
};

RadResponder.moveToGeocodeOnMap = function (address, map, zoom, noResultsFoundForSearch) {
    var searchManager = new window.Microsoft.Maps.Search.SearchManager(map);
    var geocodeRequest = {
        where: address,
        count: 5,
        bounds: map.getBounds(),//window.Microsoft.Maps.LocationRect.fromCorners(new window.Microsoft.Maps.Location(-89.999, -179.999), new window.Microsoft.Maps.Location(89.999, 179.999)),
        callback: function (response) {
            var success;
            try {
                success = response.results[0].location;
            }
            catch (e) {
                success = null;
            }

            if (success == null) {
                if (noResultsFoundForSearch) {
                    noResultsFoundForSearch(true);
                    setTimeout(function () { noResultsFoundForSearch(false) }, 5000);
                }
                return;
            }
            map.setView({ center: new window.Microsoft.Maps.Location(response.results[0].location.latitude, response.results[0].location.longitude), zoom: zoom });
        },
        errorCallback: function (userData) {
            return;
        }
    };
    searchManager.geocode(geocodeRequest);
};

RadResponder.mapToDetailsFormat = function (data, clearFieldsForReuse) {
    var loc;
    if (!data) {
        return null;
    }

    loc = data.location || data;

    var record = {
        collectionDate: data.Collection_Date || data.Date_Taken || data.Measurement_Date,
        hasCustomMetadata: data.Has_Custom_Metadata,
        fieldTeamId: data.Field_Team_Id,
        organizationId: data.Organization_Id,
        organizationIdAblu: data.Organization_Id_ABLU,
        collectedByPersonnelId: data.Personnel_Id || data.Collected_By_Personnel_Id,
        collectedByPersonnelIdAblu: data.Collected_By_Id_ABLU || data.Collected_By_Personnel_Id,
        collectedByEquipmentId: data.Collected_By_Equipment_Id,
        collectedByEquipmentIdAblu: data.Collected_By_Equipment_Id_ABLU,
        recordedById: data.Recorded_By_Id,
        recordedByIdAblu: data.Recorded_By_Id_ABLU,
        latitude: loc.Latitude,
        longitude: loc.Longitude,
        street1: loc.Street_Address || loc.Street_1,
        street2: loc.Street_Address_1 || loc.Street_2,
        city: loc.City,
        stateId: loc.State_Id,
        zipcode: loc.Zip_Code,
        samplingLocationId: loc.Sampling_Location_Id,
        facilityId: loc.Facility_Id,
        latLongProvided: loc.LatLong_Provided,
        isIndoor: loc.Is_Indoor,
        building: loc.Building,
        floor: loc.Floor,
        roomNumber: loc.Room_Number,
        directionId: loc.Direction_Id,
        surface: loc.Surface,
        material: loc.Material,
        indoorComment: loc.Indoor_Comment,
        facilityFloorPlanId: loc.Facility_Floor_Plan_Id,
        facilityFloorPlanX: loc.Facility_Floor_Plan_X,
        facilityFloorPlanY: loc.Facility_Floor_Plan_Y
    };

    if (clearFieldsForReuse === true) {
        record.facilityFloorPlanX = undefined;
        record.facilityFloorPlanY = undefined;
        record.roomNumber = undefined;
        record.directionId = undefined;
        record.surface = undefined;
        record.material = undefined;
        record.indoorComment = undefined;
    }

    return record;
};

//show new release notifications
RadResponder.checkForNewReleases = function (platformId, lengthOfCheckInDays, releaseNotesAddress) {
    return $.post(RadResponder.getApiAddress() + "release/getlatestforplatform/" + platformId)
        .done(function (data) {
            //only show if there is a release in the last 14 days
            if (!data || moment(data.Date).add(lengthOfCheckInDays, "days") < moment()) {
                return;
            }

            //check to see if a cookie for the release already exists
            var releaseCookie = $.cookie("rr-release-dismissed-" + data.Release_Id);
            if (releaseCookie) {
                //user has already dismissed the notification
                return;
            }

            //show alert
            var container = $('<div class="alert alert-info alert-dismissible alert-nobottommargin alert-square" role="alert" />');

            //append close button
            container.append($('<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>'));

            //append title
            container.append($('<strong class="right5">New Release</strong>'));
            container.append(String.format('- v{0} of the {2} was released on {1}. <a href="{3}">Read more</a> about the new features in this release.', data.Version, moment(data.Date).format("MM/DD/YYYY"), data.Platform_Id_ABLU, releaseNotesAddress));
            container.hide();

            var dismissed = false;
            container.on("closed.bs.alert", function () {
                dismissed = true;
                //add cookie saying this version has been dismissed already with an expiration of 14 days.
                $.cookie("rr-release-dismissed-" + data.Release_Id, true, { expires: lengthOfCheckInDays });
            });

            //set timer to auto close the notification after 2 minutes
            setTimeout(function () {
                if (dismissed) {
                    return;
                }
                container.find("button").click();
            }, 120000);


            //add it to the notification container
            var notificationContainer = $(".notification-container");
            notificationContainer.append(container.fadeIn(800));
        });
};

RadResponder.barcodeAsyncValidation = function (onlyIfEvaluator, barcodeToValidateAgainst, eventId, validationEnabled, isAdding, urlprefix) {
    if (RadResponder.isEmpty(urlprefix)) {
        urlprefix = "fieldsample";
    }
    var validation = {
        async: true,
        validator: function (val, params, callback) {
            //if validation not enabled, return true. or if editing and name hasn't changed
            if (!params.validationEnabled() || val === undefined || val === "" || val === null || (!params.isAdding() && val === params.barcode())) {
                callback(true);
                return;
            }

            var options = {
                url: RadResponder.getApiAddress() + "/" + urlprefix + "/issamplenumberunique",
                type: "POST",
                data: { eventId: params.eventId(), name: val.trim() },
                success: callback
            };

            $.ajax(options);
        },
        params: { barcode: barcodeToValidateAgainst, eventId: eventId, validationEnabled: validationEnabled, isAdding: isAdding },
        message: "Barcode must be unique for the event"
    };

    if (onlyIfEvaluator) {
        validation.onlyIf = onlyIfEvaluator;
    }

    return validation;
};

RadResponder.barcodePrefixValidation = {
    validator: function (value) {
        if (value && value.length > 2) {
            var prefix = value.trim().substring(0, 3).toUpperCase();
            return prefix !== RadResponder.spectraPrefix && prefix !== RadResponder.chemSampleBarcodePrefix && prefix !== RadResponder.bioSampleBarcodePrefix;
        } else {
            return true;
        }
    },
    message: "Custom ID/Barcode cannot be entered using the prefix of '" + RadResponder.spectraPrefix + "' or '" + RadResponder.chemSampleBarcodePrefix + "' or '" + RadResponder.bioSampleBarcodePrefix + "'"
}

RadResponder.barcodeCharValidation = function (validChars) {
    return {
        validator: function (value, params) {
            if (value === undefined || value === "" || value === null) {
                return true;
            }
            return _.every(value.split(""), function (c) {
                return _.contains(params, c.toUpperCase());
            });
        },
        params: validChars,
        message: "The value contains invalid characters."
    }
};

RadResponder.getIconFromFileClass = function (className) {
    var resultClasses = "fa fa-solid ";

    switch (className) {
        case "XLS":
            resultClasses += "fa-file-excel";
            break;
        case "DOC":
            resultClasses += "fa-file-word";
            break;
        case "PPT":
            resultClasses += "fa-file-powerpoint";
            break;
        case "ZIP":
            resultClasses += "fa-file-zipper";
            break;
        case "PDF":
            resultClasses += "fa-file-pdf";
            break;
        case "VID":
            resultClasses += "fa-file-video";
            break;
        case "FOLDER":
            resultClasses += "fa-folder";
            break;
        case "PHOTO":
            resultClasses += "fa fa-regular fa-image";
            break;
        case 'VIRTUALFOLDER':
            resultClasses += 'fa-folder';
            break;
        case 'VIRTUALDOC':
            resultClasses += 'fa fa-regular fa-file';
            break;
        default:
            resultClasses += "fa-file-lines";
            break;
    }

    return resultClasses;
};

RadResponder.getIconFromDataPointType = function (dataPointType, itemName) {
    var resultClasses = "fa fa-solid ";

    switch (dataPointType) {
        case "Document":
        case 109:
            resultClasses += RadResponder.getIconFromFileClass(RadResponder.getFileClassFromFileName(itemName));
            break;
        case "Directory":
        case "Resource Library Folder":
        case 120:
        case 235:
            resultClasses += " fa-folder";
            break;
        case "Training":
        case 123:
            resultClasses += " fa-graduation-cap";
            break;
        case "Tool":
        case 121:
            resultClasses += " fa-wrench";
            break;
        case "Video":
        case 122:
            resultClasses += RadResponder.getIconFromFileClass("VID");
            break;
        default:
            resultClasses += " fa-star";
            break;
    }

    return resultClasses;
};

RadResponder.getFileClassFromFileName = function (fileName) {
    var extension = fileName.toUpperCase().substring(fileName.lastIndexOf("."));
    switch (extension) {
        case ".XLSX":
        case ".XLS":
            return "XLS";
        case ".DOCX":
        case ".DOC":
            return "DOC";
        case ".PPTX":
        case ".PPT":
            return "PPT";
        case ".ZIP":
            return "ZIP";
        case ".PDF":
            return "PDF";
        case ".MOV":
        case ".MP4":
            return "VID";
        case ".JPG":
        case ".JPEG":
        case ".PNG":
        case ".GIF":
            return "PHOTO";
    }
};

RadResponder.convertCelsiusToFahrenheit = function (temperature) {
    return Math.round((temperature * 1.8) + 32);
};

RadResponder.convertCelsiusToKelvin = function (temperature) {
    return Math.round(temperature + 273.15);
};

RadResponder.convertFahrenheitToCelsius = function (temperature) {
    return Math.round((temperature - 32) / 1.8);
};

RadResponder.convertFahrenheitToKelvin = function (temperature) {
    return Math.round(((temperature - 32) / 1.8) + 273.15);
};

RadResponder.convertKelvinToCelsius = function (temperature) {
    return Math.round(temperature - 273.15);
};

RadResponder.convertKelvinToFahrenheit = function (temperature) {
    return Math.round(((temperature - 273.15) * 1.8) + 32);
};

RadResponder.changeType = {
    insert: 0,
    update: 1,
    delete: 2,
    nochange: 3
};


RadResponder.getDataTypePathName = function (dataPointTypeId) {
    var dataTypePathName = null;

    switch (dataPointTypeId) {
        case RadResponder.dataPointTypes.organization:
            dataTypePathName = "organization";
            break;
        case RadResponder.dataPointTypes.survey:
            dataTypePathName = "surveys";
            break;
        case RadResponder.dataPointTypes.sample:
            dataTypePathName = "samples";
            break;
        case RadResponder.dataPointTypes.fieldScreening:
            dataTypePathName = "fieldscreenings";
            break;
        case RadResponder.dataPointTypes.observation:
            dataTypePathName = "observations";
            break;
        case RadResponder.dataPointTypes.spectra:
            dataTypePathName = "spectras";
            break;
        case RadResponder.dataPointTypes.set:
            dataTypePathName = "datacollectionsets";
            break;
        case RadResponder.dataPointTypes.result:
            dataTypePathName = "results";
            break;
        case RadResponder.dataPointTypes.aerialSurvey:
            dataTypePathName = "mobile/surveys";
            break;
        case RadResponder.dataPointTypes.aerialReading:
            dataTypePathName = "mobile/readings";
            break;
        case RadResponder.dataPointTypes.sitrep:
            dataTypePathName = "sitreps";
            break;
        case RadResponder.dataPointTypes.chemicalId:
            dataTypePathName = "chemicalids";
            break;
        case RadResponder.dataPointTypes.chemicalReading:
            dataTypePathName = "chemicalreadings";
            break;
        case RadResponder.dataPointTypes.chemicalSample:
            dataTypePathName = "chemicalsamples";
            break;
        case RadResponder.dataPointTypes.bioSample:
            dataTypePathName = "biosamples";
            break;
        case RadResponder.dataPointTypes.chemicalSpectra:
            dataTypePathName = "chemicalspectra";
            break;
        case RadResponder.dataPointTypes.colorimetricReading:
            dataTypePathName = "colorimetricreadings";
            break;
        case RadResponder.dataPointTypes.dose:
            dataTypePathName = "dosimetry/readings";
            break;
        case RadResponder.dataPointTypes.accumulatedDose:
            dataTypePathName = "dosimetry/accumulated";
            break;
        case RadResponder.dataPointTypes.analysisRequest:
            dataTypePathName = "analysisrequests";
            break;
        case RadResponder.dataPointTypes.bioScreening:
            dataTypePathName = "bioscreenings";
            break;
        case RadResponder.dataPointTypes.bioSitrep:
            dataTypePathName = "biositreps";
            break;
        case RadResponder.dataPointTypes.assignment:
            dataTypePathName = "assignments";
            break;
        case RadResponder.dataPointTypes.event:
            dataTypePathName = "event";
            break;
        case RadResponder.dataPointTypes.chemicalAnalyticalResult:
            dataTypePathName = "chemicalanalyticalresults";
            break;
        case RadResponder.dataPointTypes.fixedPointSurvey:
            dataTypePathName = "fixedpointsurveys";
            break;
        case RadResponder.dataPointTypes.fixedChemicalReading:
            dataTypePathName = "fixedchemicalreadings";
            break;
        default:
            break;
    }

    return dataTypePathName;
};

RadResponder.getDetailsLinkFromDataPointInfo = function (dataPointTypeId, validEventId, eventId, rootPathOverride) {
    var dataTypePathName = RadResponder.getDataTypePathName(dataPointTypeId);

    if (!dataTypePathName) {
        return null;
    }
    var rootPath = rootPathOverride ? rootPathOverride : String.format("event/{0}", validEventId || eventId);
    if (validEventId || dataPointTypeId === RadResponder.dataPointTypes.accumulatedDose) {
        return String.format("{0}app/index#{1}/{2}/details/", RadResponder.getWebsiteAddress(), rootPath, dataTypePathName);
    }
    return String.format("{0}app/index#{1}/details/", RadResponder.getWebsiteAddress(), dataTypePathName);
};

RadResponder.getServerSideApiRootPath = function (dataPointTypeId) {
    var dataTypePathName = null;

    switch (dataPointTypeId) {
        case RadResponder.dataPointTypes.survey:
            dataTypePathName = "fieldsurvey";
            break;
        case RadResponder.dataPointTypes.sample:
            dataTypePathName = "fieldsample";
            break;
        case RadResponder.dataPointTypes.fieldScreening:
            dataTypePathName = "fieldscreening";
            break;
        case RadResponder.dataPointTypes.observation:
            dataTypePathName = "observation";
            break;
        case RadResponder.dataPointTypes.spectra:
            dataTypePathName = "spectra";
            break;
        case RadResponder.dataPointTypes.set:
            dataTypePathName = "fieldactivity";
            break;
        case RadResponder.dataPointTypes.result:
            dataTypePathName = "fieldsampleresult";
            break;
        case RadResponder.dataPointTypes.aerialSurvey:
            dataTypePathName = "aerialsurvey";
            break;
        case RadResponder.dataPointTypes.aerialReading:
            dataTypePathName = "aerialreading";
            break;
        case RadResponder.dataPointTypes.sitrep:
            dataTypePathName = "sitrep";
            break;
        case RadResponder.dataPointTypes.chemicalId:
            dataTypePathName = "chemicalid";
            break;
        case RadResponder.dataPointTypes.chemicalReading:
            dataTypePathName = "chemicalreading";
            break;
        case RadResponder.dataPointTypes.chemicalSample:
            dataTypePathName = "chemicalsample";
            break;
        case RadResponder.dataPointTypes.bioSample:
            dataTypePathName = "biosample";
            break;
        case RadResponder.dataPointTypes.chemicalSpectra:
            dataTypePathName = "chemicalspectrum";
            break;
        case RadResponder.dataPointTypes.colorimetricReading:
            dataTypePathName = "colorimetricreading";
            break;
        case RadResponder.dataPointTypes.dose:
            dataTypePathName = "dosimetry/reading";
            break;
        case RadResponder.dataPointTypes.accumulatedDose:
            dataTypePathName = "dosimetry/accumulated";
            break;
        case RadResponder.dataPointTypes.analysisRequest:
            dataTypePathName = "analysisrequest";
            break;
        case RadResponder.dataPointTypes.bioScreening:
            dataTypePathName = "bioscreening";
            break;
        case RadResponder.dataPointTypes.bioSitrep:
            dataTypePathName = "biositrep";
            break;
        case RadResponder.dataPointTypes.chemicalAnalyticalResult:
            dataTypePathName = "chemicalAnalyticalResult";
            break;
        default:
            break;
    }

    return RadResponder.getApiAddress() + dataTypePathName;
};

RadResponder.getFormattedStringForDataPointType = function (dataPointTypeId, organizationOverride) {
    switch (dataPointTypeId) {
        case RadResponder.dataPointTypes.survey:
            return "Field Survey";
        case RadResponder.dataPointTypes.sample:
            return "Field Sample";
        case RadResponder.dataPointTypes.observation:
            return "Observation";
        case RadResponder.dataPointTypes.spectra:
            return "Radiological Spectrum";
        case RadResponder.dataPointTypes.set:
            return "Set";
        case RadResponder.dataPointTypes.result:
            return "Radiological Analytical Result";
        case RadResponder.dataPointTypes.mobileSurveySegment:
            return "Mobile Survey Segment";
        case RadResponder.dataPointTypes.aerialSurvey:
            return "Mobile Survey";
        case RadResponder.dataPointTypes.aerialReading:
            return "Mobile Reading";
        case RadResponder.dataPointTypes.sitrep:
            return "Chemical SITREP";
        case RadResponder.dataPointTypes.chemicalId:
            return "Chemical ID";
        case RadResponder.dataPointTypes.chemicalReading:
            return "Chemical Reading";
        case RadResponder.dataPointTypes.chemicalSample:
            return "Chemical Sample";
        case RadResponder.dataPointTypes.bioSample:
            return "Biological Sample";
        case RadResponder.dataPointTypes.chemicalSpectra:
            return "Chemical Spectrum";
        case RadResponder.dataPointTypes.colorimetricReading:
            return "Colorimetric Reading";
        case RadResponder.dataPointTypes.dose:
            return "Dose Reading";
        case RadResponder.dataPointTypes.accumulatedDose:
            return "Accumulated Dose";
        case RadResponder.dataPointTypes.event:
            return "Event";
        case RadResponder.dataPointTypes.releasePoint:
            return "Release Point";
        case RadResponder.dataPointTypes.organization:
            return organizationOverride || "Organization";
        case RadResponder.dataPointTypes.dataFeedLocation:
            return "Data Feed Location";
        case RadResponder.dataPointTypes.archivedDataFeedLocation:
            return "Historical Data Feed Location";
        case RadResponder.dataPointTypes.eventFacility:
        case RadResponder.dataPointTypes.facility:
            return "Facility";
        case RadResponder.dataPointTypes.samplingLocation:
            return "Sampling Location";
        case RadResponder.dataPointTypes.radnetLocation:
            return "EPA RadNet Location";
        case RadResponder.dataPointTypes.responder:
            return "Responder";
        case RadResponder.dataPointTypes.assignment:
            return "Assignment";
        case RadResponder.dataPointTypes.ross:
            return "ROSS Personnel";
        case RadResponder.dataPointTypes.fixedPointSurvey:
            return "Fixed Point Survey";
        case RadResponder.dataPointTypes.fixedChemicalReading:
            return "Fixed Chemical Reading";
        case RadResponder.dataPointTypes.fieldScreening:
            return "Field Screening";
        case RadResponder.dataPointTypes.equipment:
            return "Equipment";
        case RadResponder.dataPointTypes.bioScreening:
            return "COVID-19 Test";
        case RadResponder.dataPointTypes.bioSitrep:
            return "Biological SITREP";
        case RadResponder.dataPointTypes.laboratory:
            return "Laboratory";
        case RadResponder.dataPointTypes.chemicalAnalyticalResult:
            return "Chemical Analytical Result";
        case RadResponder.dataPointTypes.equipmentTemplate:
            return "Equipment Template";
        case RadResponder.dataPointTypes.indoorSamplingLocation:
            return "Indoor Sampling Location";
    }
};

RadResponder.getMapFormattedStringForDataPointType = function (dataPointTypeId, organizationOverride) {
    switch (dataPointTypeId) {
        case RadResponder.dataPointTypes.spectra:
            return "Radiological Spectra";
        case RadResponder.dataPointTypes.sitrep:
            return "Chemical SITREPs";
        case RadResponder.dataPointTypes.chemicalId:
            return "Chemical IDs";
        case RadResponder.dataPointTypes.chemicalSpectra:
            return "Chemical Spectra";
        case RadResponder.dataPointTypes.eventFacility:
        case RadResponder.dataPointTypes.facility:
            return "Facilities";
        case RadResponder.dataPointTypes.ross:
            return "ROSS Personnel";
        case RadResponder.dataPointTypes.imsLocation:
            return "IMS Locations"
        case RadResponder.dataPointTypes.bioScreening:
            return "COVID-19 Tests";
        case RadResponder.dataPointTypes.bioSitrep:
            return "Biological SITREPs";
        case RadResponder.dataPointTypes.laboratory:
            return "Laboratories";
        default:
            return RadResponder.getFormattedStringForDataPointType(dataPointTypeId, organizationOverride) + "s";
    }
};

RadResponder.getFormattedStringForModule = function (moduleId) {
    switch (moduleId) {
        case RadResponder.modules.resourceLibrary:
            return "Resource";
        case RadResponder.modules.organization:
            return "Organization";
        case RadResponder.modules.event:
            return "Event";
        case RadResponder.modules.imaac:
            return "IMAAC";
        case RadResponder.modules.poi:
            return "Mobile Resources Sets";
        default:
            throw "Invalid module type";
    }
};


RadResponder.locationRenderer = function (options, object) {
    if (!object) {
        return "--";
    }

    if (!options || (options && (!options.hasOwnProperty("useSamplingLocationOrFacility") || !!options["useSamplingLocationOrFacility"]))) {
        //sampling location or facility
        if (object["Sampling_Location_Id"] && object["Sampling_Location_Id_ABLU"]) {
            return (object["Facility_Id_ABLU"] ? object["Facility_Id_ABLU"] + " - " : "") + object["Sampling_Location_Id_ABLU"];
        } else if (object["Facility_Id"] && object["Facility_Id_ABLU"]) {
            return object["Facility_Id_ABLU"];
        }
    }

    var streetAddress = object["Street_1"] || object["Street_Address"];
    var streetAddress2 = object["Street_Address_1"] || object["Street_2"];
    //address
    if (streetAddress || streetAddress2 || object["City"] || object["State_Id_ABLU"] || object["Zip_Code"]) {
        var address = "";
        if (streetAddress) {
            address += streetAddress + "<br />";
        }
        if (streetAddress2) {
            address += streetAddress2 + "<br />";
        }
        if (object["City"]) {
            address += object["City"] + (object["State_Id_ABLU"] ? ", " : "");
        }
        if (object["State_Id_ABLU"]) {
            address += object["State_Id_ABLU"] + " ";
        }
        if (object["Zip_Code"]) {
            address += object["Zip_Code"];
        }
        return address.length > 0 ? address : "--";
    }

    //lat/long
    if (object["Latitude"] && object["Longitude"]) {
        return object["Latitude"] + ", " + object["Longitude"];
    }
    if (object["Latitude_Center"] && object["Longitude_Center"]) {
        return object["Latitude_Center"] + ", " + object["Longitude_Center"];
    }

    return "--";
};

RadResponder.htmlEncode = function (value) {
    // Create a in-memory element, set its inner text (which is automatically encoded)
    // Then grab the encoded contents back out. The element never exists on the DOM.
    return $('<textarea/>').text(value).html();
};

RadResponder.htmlDecode = function (value) {
    return $('<textarea/>').html(value).text();
};

RadResponder.formats = {
    Date: "MM/DD/YYYY",
    Time: "HH:mm",
    MonthAndYear: "MM/YYYY"
};
RadResponder.formats.DateTime = RadResponder.formats.Date + " " + RadResponder.formats.Time;
RadResponder.formats.DateTimeWithSeconds = RadResponder.formats.DateTime + ":ss";

RadResponder.sizeQueries = {
    greaterThanXtraSmall: '(min-width: 768px)',
    greaterThanSmall: '(min-width: 992px)',
    greaterThanMedium: '(min-width: 1200px)',
    greaterThanLarge: '(min-width: 1600px)',
    lessThanSmall: '(max-width: 767px)',
    lessThanMedium: '(max-width: 991px)',
    lessThanLarge: '(max-width: 1199px)',
    lessThanXtraLarge: '(max-width: 1599px)'
};
RadResponder.sizeQueries.xtraSmall = RadResponder.sizeQueries.lessThanSmall;
RadResponder.sizeQueries.small = RadResponder.sizeQueries.greaterThanXtraSmall + ' and ' + RadResponder.sizeQueries.lessThanMedium;
RadResponder.sizeQueries.medium = RadResponder.sizeQueries.greaterThanSmall + ' and ' + RadResponder.sizeQueries.lessThanLarge;
RadResponder.sizeQueries.large = RadResponder.sizeQueries.greaterThanMedium + ' and ' + RadResponder.sizeQueries.lessThanXtraLarge;
RadResponder.sizeQueries.xtraLarge = RadResponder.sizeQueries.greaterThanLarge;

RadResponder.ajaxGet = function (parameters) {
    var parameterObject = parameters || {};

    parameterObject = typeof parameterObject === 'string' || parameterObject instanceof String ? { url: parameterObject } : parameterObject;

    return $.ajax($.extend(parameterObject, {
        type: 'GET',
        cache: false
    }));
};


RadResponder.formatAnalyticalResults = function (results) {
    return _.map(results, function (item) {
        return {
            id: item.Field_Sample_Result_Id,
            analysisRequest: item.Analysis_Request_Id_ABLU,
            laboratoryName: item.Laboratory_Data_Point_Id_ABLU,
            analysisMethodName: item.Analysis_Method_Id_ABLU,
            nuclideTypeName: item.Nuclide_Type_Id_ABLU,
            result: item.Result_Display,
            measurmentUnitName: item.Result_Unit_Id_ABLU,
            criticalLevel: item.Measured_Critical_Level,
            status: item.Current_Analysis_Status_Id_ABLU,
            formattedValue: item.Result_Display && item.Result_Unit_Id_ABLU ? item.Result_Display + " " + item.Result_Unit_Id_ABLU : null
        };
    });
};

RadResponder.formatChemicalAnalyticalResults = (results) => {
    return _.map(results, (item) => {
        return {
            id: item.Chemical_Analytical_Result_Id,
            analysisRequest: item.Analysis_Request_Id_ABLU,
            laboratoryName: item.Laboratory_Data_Point_Id_ABLU,
            analysisMethodName: item.Analysis_Method_Id_ABLU,
            chemicalName: item.Chemical_Id_ABLU,
            result: item.Result_Display,
            measurmentUnitName: item.Result_Concentration_Unit_Id_ABLU,
            status: item.Current_Analysis_Status_Id_ABLU,
            formattedValue: item.Result_Display && item.Result_Concentration_Unit_Id_ABLU ? item.Result_Display + " " + item.Result_Concentration_Unit_Id_ABLU : null
        };
    });
};

RadResponder.spectraPrefix = "SPC";

RadResponder.chemSampleBarcodePrefix = "CSN";
RadResponder.bioSampleBarcodePrefix = "BSN";


RadResponder.formatScientificNotation = function (data) {
    data = parseFloat(data);
    if (isNaN(data)) {
        return null;
    }
    if (data === 0) {
        return 0;
    }
    return data.toExponential(3);
};

RadResponder.apiTypes = { read: 105, equipment: 103, fixedData: 100, userData: 101 };
RadResponder.printValidationErrorsToConsole = function (vm) {
    for (var propName in vm) {
        if (vm.hasOwnProperty(propName)) {
            if (vm[propName] && vm[propName].isValid && !vm[propName].isValid()) {
                console.log(propName, vm[propName].isValid());
            }
        }
    }
};
RadResponder.noDataFeedsWarning = "<strong>Note: </strong>The event does not have any data feeds. The event must have at least one data feed to be able to view fixed monitoring data."
RadResponder.noRadDataFeedsWarning = "<strong>Note: </strong>The event does not have any radiological data feeds. The event must have at least one radiological data feed to be able to view fixed point survey data."
RadResponder.noChemDataFeedsWarning = "<strong>Note: </strong>The event does not have any chemical data feeds. The event must have at least one chemical data feed to be able to view fixed chemical reading data."
RadResponder.noOrgDataFeedsWarning = "<strong>Note: </strong>The organization does not have any data feeds. The organization must have at least one data feed to be able to view fixed monitoring data."
RadResponder.noOrgRadDataFeedsWarning = "<strong>Note: </strong>The organization does not have any radiological data feeds. The organization must have at least one radiological data feed to be able to view fixed point survey data."
RadResponder.noOrgChemDataFeedsWarning = "<strong>Note: </strong>The organization does not have any chemical data feeds. The organization must have at least one chemical data feed to be able to view fixed chemical reading data."


RadResponder.normalizeHex = function (hex) {
    return hex.length > 1 ? hex : '0' + hex;
};

RadResponder.doesDataPointTypeSupportEventThreshold = function (dataPointType) {
    var excludedTypes = [RadResponder.dataPointTypes.fixedPointSurvey, RadResponder.dataPointTypes.fixedChemicalReading]
    return !excludedTypes.includes(dataPointType)
}

RadResponder.facilityStatusTypes = { open: 100, suspended: 101, closed: 102, live: 103, pending: 104, onHold: 105 }

RadResponder.severityLevels = {
    background: 0,
    low: 1,
    medium: 2,
    high: 3,
    veryHigh: 4,
    pending: -1,
    unableToCalculate: -2
};

RadResponder.n42ParserMeasurementCodes = {
    foreground: 0,
    background: 1,
    calibration: 2,
    intrinsicActivity: 3,
    notSpecified: 4
};

RadResponder.modules = {
    resourceLibrary: 100,
    organization: 101,
    event: 102,
    imaac: 103,
    pio:104
};

RadResponder.downloadDeliveryMethod = {
    email: 1,
    signalR: 2,
    direct: 3,
};

RadResponder.moduleRoles = {
    administrator: 100,
    analyst: 101,
    viewer: 102
};
RadResponder.platformType = {
    iOS: 103,
    android: 104,
    windows: 105
};
RadResponder.mobileAppType = {
    rr: 100,
    cr: 101,
    cbrn: 102
};

RadResponder.hasHtml = function (value) {
    return /<\/?[a-z][\s\S]*>/i.test(value)
};

RadResponder.importTypesWithIndoorFields = [RadResponder.importTypes.survey, RadResponder.importTypes.fieldSample, RadResponder.importTypes.assignment];

RadResponder.titleCase = function (str) {
    var splitStr = str.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
};

RadResponder.calculateHypotenuseDistanceFromPoints = function (startX, startY, endX, endY) {
    if (RadResponder.isEmpty(startX)
        || RadResponder.isEmpty(startY)
        || RadResponder.isEmpty(endX)
        || RadResponder.isEmpty(endY)) {
        return null;
    }
    return Math.sqrt(Math.pow(endX - startX, 2) + Math.pow(endY - startY, 2));
};
// https://stackoverflow.com/questions/7905929/how-to-test-valid-uuid-guid
RadResponder.UuidValidator = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

RadResponder.makeGuid = function () {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + "-" + s4() + "-" + s4() + "-" +
        s4() + "-" + s4() + s4() + s4();
};

RadResponder.isInteger = function (str) {
    var n = Math.floor(Number(str));
    return n !== Infinity && String(n) === String(str) && String(str) !== 'NaN';
};





RadResponder.permissions = {};
RadResponder.permissions.eventPermissions = {
    view: "View",
    open: "Open",
    close: "Close",
    delete: "Delete",
    edit: "Edit",
    managePersonnel: "ManagePersonnel",
    managePartners: "ManagePartners",
    manageTeams: "ManageTeams",
    editTeamOwner: "EditTeamOwner",
    manageDataFeeds: "ManageDataFeeds",
    manageDocuments: "ManageDocuments",
    manageFacilities: "ManageFacilities",
    manageSampleTypes: "ManageSampleTypes",
    manageSurveyThresholds: "ManageSurveyThresholds",
    manageMixture: "ManageMixture",
    manageAnalysisRequest: "ManageAnalysisRequest",
    manageEquipment: "ManageEquipment",
    viewFieldSurveys: "ViewFieldSurveys",
    viewOnlyApprovedFieldSurveys: "ViewOnlyApprovedFieldSurveys",
    viewFixedPointSurveys: "ViewFixedPointSurveys",
    viewFixedChemicalReadings: "ViewFixedChemicalReadings",
    viewFieldSamples: "ViewFieldSamples",
    viewFieldSampleResults: "ViewFieldSampleResults",
    viewOnlyApprovedFieldSampleResults: "ViewOnlyApprovedFieldSampleResults",
    viewObservations: "ViewObservations",
    viewDataPointAttachments: "ViewDataPointAttachments",
    viewDataPointAssociations: "ViewDataPointAssociations",
    manageDataPointAssociations: "ManageDataPointAssociations",
    manageEventEfficiency: "ManageEventEfficiency",
    manageEventEquipmentEfficiencyOverride: "ManageEventEquipmentEfficiencyOverride",
    viewEquipmentEfficiency: "ViewEquipmentEfficiency",
    viewSpectras: "ViewSpectras",
    viewChemicalIdentifications: "ViewChemicalIdentifications",
    viewChemicalReadings: "ViewChemicalReadings",
    viewChemicalSpectra: "ViewChemicalSpectra",
    viewColorimetricReadings: "ViewColorimetricReadings",
    viewLessonsLearned: "ViewLessonsLearned",
    viewOnlyApprovedSpectras: "ViewOnlyApprovedSpectras",
    viewOnlyApprovedChemicalReadings: "ViewOnlyApprovedChemicalReadings",
    viewOnlyApprovedChemicalSpectra: "ViewOnlyApprovedChemicalSpectra",
    viewOnlyApprovedChemicalIdentifications: "ViewOnlyApprovedChemicalIdentifications",
    viewOnlyApprovedColorimetricReadings: "ViewOnlyApprovedColorimetricReadings",
    viewSitreps: "ViewSitreps",
    viewDataSets: "ViewDataSets",
    viewOnlyApprovedDataSets: "ViewOnlyApprovedDataSets",
    viewMixture: "ViewMixture",
    viewAnalysisRequest: "ViewAnalysisRequest",
    viewResponderTracking: "ViewResponderTracking",
    deleteResponderTracking: "DeleteResponderTracking",
    collectFieldSurveys: "CollectFieldSurveys",
    collectFieldSamples: "CollectFieldSamples",
    collectObservations: "CollectObservations",
    collectSpectras: "CollectSpectras",
    collectSitreps: "CollectSitreps",
    collectChemicalIdentifications: "CollectChemicalIdentifications",
    collectColorimetricReadings: "CollectColorimetricReadings",
    collectLessonsLearned: "CollectLessonsLearned",
    collectChemicalReadings: "CollectChemicalReadings",
    collectChemicalSamples: "CollectChemicalSamples",
    collectBioSamples: "CollectBioSamples",
    collectChemicalSpectra: "CollectChemicalSpectra",
    collectDataSets: "CollectDataSets",
    recordFieldSampleResults: "RecordFieldSampleResults",
    assessFieldSurveys: "AssessFieldSurveys",
    assessFieldSampleResults: "AssessFieldSampleResults",
    assessSpectras: "AssessSpectras",
    assessColorimetric: "AssessColorimetric",
    assessChemicalIdentification: "AssessChemicalIdentification",
    assessChemicalReading: "AssessChemicalReading",
    assessChemicalSpectrum: "AssessChemicalSpectrum",
    assessAerialReadings: "AssessAerialReadings",
    viewLog: "ViewLog",
    manageGisFiles: "ManageGisFiles",
    manageTenPointMonitoring: "ManageTenPointMonitoring",
    manageImports: "ManageImports",
    viewSimulations: "ViewSimulations",
    manageSimulations: "ManageSimulations",
    runSimulationDataGenerator: "RunSimulationDataGenerator",
    manageDataCollectionSetTemplates: "ManageDataCollectionSetTemplates",
    escalateToEmergency: "EscalateToEmergency",
    viewPopulationMonitoring: "ViewPopulationMonitoring",
    collectScreenedPopulation: "CollectScreenedPopulation",
    manageUserDrawings: "ManageUserDrawings",
    runEventSummaryReport: "RunEventSummaryReport",
    runSampleControlFormReport: "RunSampleControlFormReport",
    runAnalysisRequestReport: "RunAnalysisRequestReport",
    runFieldTeamReport: "RunFieldTeamReport",
    runEventDosimetryReport: "RunEventDosimetryReport",
    manageMerge: "ManageMerge",
    manageAlertDefinitions: "ManageAlertDefinitions",
    viewAlertDefinitions: "ViewAlertDefinitions",
    viewAlertHistory: "ViewAlertHistory",
    manageIsActiveEmergency: "ManageIsActiveEmergency",
    completeDataCollectionAssignments: "CompleteDataCollectionAssignments",
    viewDataCollectionAssignments: "ViewDataCollectionAssignments",
    manageDataCollectionAssignments: "ManageDataCollectionAssignments",
    collectMobileSurveys: "CollectMobileSurveys",
    viewAerialReadings: "ViewAerialReadings",
    viewAerialSurveys: "ViewAerialSurveys",
    viewOnlyApprovedAerialReadings: "ViewOnlyApprovedAerialReadings",
    viewOnlyApprovedAerialSurveys: "ViewOnlyApprovedAerialSurveys",
    deleteAerialReadings: "DeleteAerialReadings",
    deleteAerialSurveys: "DeleteAerialSurveys",
    viewEventThresholds: "ViewEventThresholds",
    manageEventThresholds: "ManageEventThresholds",
    viewDosimetry: "ViewDosimetry",
    viewDosimetryWithPersonnelDetails: "ViewDosimetryWithPersonnelDetails",
    collectDosimetry: "CollectDosimetry",
    collectDosimetryForOtherPersonnel: "CollectDosimetryForOtherPersonnel",
    modifyDosimetry: "ModifyDosimetry",
    assessDosimetry: "AssessDosimetry",
    reseedPersonnelAliases: "ReseedPersonnelAliases",
    viewEquipmentAssignments: "ViewEquipmentAssignments",
    manageEquipmentAssignments: "ManageEquipmentAssignments",
    manageMyEquipmentAssignments: "ManageMyEquipmentAssignments",
    viewFacilitiesFloorPlans: "ViewFacilitiesFloorPlans",
    manageFacilitiesFloorPlans: "ManageFacilitiesFloorPlans",
    setSampleStatusReceived: "SetSampleStatusReceived",
    setSampleStatusReturned: "SetSampleStatusReturned",
    setSampleStatusDisposed: "SetSampleStatusDisposed",
    canViewDataVerification: "CanViewDataVerification",
    canManageDataVerification: "CanManageDataVerification",
    viewNonConformance: "ViewNonConformance",
    manageNonConformance: "ManageNonConformance",
    canResolveNonConformance: "CanResolveNonConformance",
    collectAttachments: "CollectAttachments",
    collectFieldScreening: "CollectFieldScreening",
    viewFieldScreening: "ViewFieldScreening",
    manageFieldScreeningLink: "ManageFieldScreeningLink",
    markAnalysisRequestAsRecieved: "MarkAnalysisRequestAsRecieved",
    viewMessageBoard: "ViewMessageBoard",
    manageMessageBoard: "ManageMessageBoard",
    canReplyMessageBoard: "CanReplyMessageBoard",
    canResolveMessageBoard: "CanResolveMessageBoard",
    manageStandardizedUnits: "ManageStandardizedUnits",
    manageResponderColor: "ManageResponderColor",
    collectBioScreenings: "CollectBioScreenings",
    viewBioScreenings: "ViewBioScreenings",
    viewFacilityTotalTestHistory: "ViewFacilityTotalTestHistory",
    manageFacilityTotalTests: "ManageFacilityTotalTests",
    collectBioSitreps: "CollectBioSitreps",
    viewBioSitreps: "ViewBioSitreps",
    viewEventMapSavedConfiguration: "ViewEventMapSavedConfiguration",
    manageEventMapSavedConfiguration: "ManageEventMapSavedConfiguration",
    documentLibraryManage: "DocumentLibraryManage",
    documentLibraryAdd: "DocumentLibraryAdd",
    documentLibraryEdit: "DocumentLibraryEdit",
    documentLibraryDelete: "DocumentLibraryDelete",
    documentLibraryView: "DocumentLibraryView",
    canCollectAtLeastOneDataType: "CanCollectAtLeastOneDataType",
};
RadResponder.permissions.globalPermissions = {
    viewSystemEquipment: 1,
    viewChemicals: 2,
    requestChemical: 3
};

RadResponder.getEditableDataTypes = function (permissions) {
    var collectableDataTypes = [];

    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectDataSets)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.set);
    }
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectObservations)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.observation);
    }
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectLessonsLearned)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.lessonLearned);
    }
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.manageDataCollectionAssignments)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.assignment);
    }

    //rad
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectFieldSurveys)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.survey);
    }
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectFieldSamples)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.sample);
    }
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectSpectras)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.spectra);
    }
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectDosimetry)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.dose);
    }
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectFieldScreening)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.fieldScreening);
    }
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectMobileSurveys)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.aerialSurvey);
    }

    //chemical
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectChemicalReadings)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.chemicalReading);
    }
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectChemicalSamples)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.chemicalSample);
    }
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectChemicalIdentifications)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.chemicalId);
    }
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectChemicalSpectra)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.chemicalSpectra);
    }
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectColorimetricReadings)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.colorimetricReading);
    }
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectSitreps)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.sitrep);
    }

    //bio
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectBioSamples)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.bioSample);
    }
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectBioScreenings)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.bioScreening);
    }
    if (_.contains(permissions, RadResponder.permissions.eventPermissions.collectBioSitreps)) {
        collectableDataTypes.push(RadResponder.dataPointTypes.bioSitrep);
    }

    return collectableDataTypes;
};


RadResponder.getIconForHazardType = function (hazardTypeId) {
    switch (parseInt(hazardTypeId)) {
        case RadResponder.hazardTypes.radiological:
            return " fa fa-solid cb-Radiation green";
        case RadResponder.hazardTypes.chemical:
            return " fa fa-solid fa-flask orange";
        case RadResponder.hazardTypes.biological:
            return " fa fa-solid fa-medkit red";
        default:
            throw "Invalid Hazard Type";
    }
};
RadResponder.getIconForHazardTypes = function (hazardTypesAsString) {
    var hazardTypes = hazardTypesAsString.split("|");
    var iconTextArray = [];
    for (var i = 0; i < hazardTypes.length; i++) {
        iconTextArray.push(RadResponder.getIconForHazardType(hazardTypes[i] + " fa-lg "));
    }
    return iconTextArray;
};

RadResponder.commonText = {
    assessmentStatusApprovedStepDisabledTooltip: "While in assessment mode, this filter is disabled because it could conflict with the assessment step and status chosen in the filters above.",
    workAuthorizationValidationMessage: "User accounts cannot be approved for requests by individuals that answered \"No\" for the Work Authorization Acknowledgment. If you have questions, please contact support@cbrnresponder.net",
    obfuscatedDescription: "Details of this record are not visible to you. This record has not yet been assessed by the owning organization, and they have elected to only release data after it has been assessed. For situational awareness, you are allowed to see who owns the data and when and where it was collected.",
    parentObfuscatedDescription: "At least one record has not yet been assessed by the owning organization, and they have elected to only release data after it has been assessed. For situational awareness, you are allowed to see who owns the data and when and where it was collected..",
    accountRequestDisclaimer: "The CBRNResponder Network is intended for use by US citizens. Only US-based organizations with equities in chemical, biological, radiological/nuclear preparedness, training, response, recovery, or other element of technical hazard engagement are allowed access to The CBRNResponder Network.",
    save: "Save",
    saveChanges: "Save Changes",
    quickSearchText: "Search text is matched against "
};

RadResponder.downloadImaacModelRequestReport = function (modelRequestId, downloadType) {
    if (!downloadType) {
        downloadType = 'direct';
    }
    return RadResponder.fileDownload(RadResponder.getApiAddress() + 'modelrequest/downloadreport', {
        data: {
            modelRequestId: modelRequestId,
            downloadType: downloadType,
        }
    });
};

RadResponder.stripHTML = function(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
};


RadResponder.getContextDataPointTypeIdFromFragment = function (router) {
    if (router.activeInstruction().fragment.indexOf("event/") >= 0) {
        return RadResponder.dataPointTypes.event;
    } else if (router.activeInstruction().fragment.indexOf("organization/") >= 0) {
        return RadResponder.dataPointTypes.organization;
    } else {
        return null;
    }
}

RadResponder.dateRangeOptions = {
    sevenDays: {
        id: 1,
        name: 'Last 7 Days',
    },
    thirtyDays: {
        id: 2,
        name: 'Last 30 Days',
    },
    thisMonth: {
        id: 3,
        name: 'This Month',
    },
    lastMonth: {
        id: 4,
        name: 'Last Month',
    },
    ninetyDays: {
        id: 5,
        name: 'Last 90 Days',
    },
    sixMonths: {
        id: 6,
        name: 'Last 6 Months',
    },
    yearToDate: {
        id: 7,
        name: 'Year to Date',
    },
    custom: {
        id: 8,
        name: 'Custom',
    },
    none: {
        id: 9,
        name: 'No Date Range',
    },
    today: {
        id: 10,
        name: 'Just Today',
    },
    twentyFourHours: {
        id: 11,
        name: 'Last 24 Hours',
    },
};

RadResponder.dateIntervalTypes = {
    day: {
        id: 1,
        name: 'Daily',
    },
    week: {
        id: 2,
        name: 'Weekly',
    },
    month: {
        id: 3,
        name: 'Monthly',
    },
};

RadResponder.getDateRangeSelectionOptions = function (session, saveSession, notRequired, defaultDateOptionRange) {

    var self = {};

    self.dateFilterOptions = ko.observableArray([
        RadResponder.dateRangeOptions.today,
        RadResponder.dateRangeOptions.twentyFourHours,
        RadResponder.dateRangeOptions.sevenDays,
        RadResponder.dateRangeOptions.thirtyDays,
        RadResponder.dateRangeOptions.thisMonth,
        RadResponder.dateRangeOptions.lastMonth,
        RadResponder.dateRangeOptions.ninetyDays,
        RadResponder.dateRangeOptions.sixMonths,
        RadResponder.dateRangeOptions.yearToDate,
        RadResponder.dateRangeOptions.custom,
        RadResponder.dateRangeOptions.none,
    ]).selectable(defaultDateOptionRange ?? RadResponder.dateRangeOptions.none.id);

    self.startDate = ko.observable();
    self.endDate = ko.observable();

    if (saveSession) {

        self.dateFilterOptions.selectedId.extend({ persist: 'selectedDateFilterOption' });
        self.startDate.extend({ persist: 'selectedStartDate' });
        self.endDate.extend({ persist: 'selectedEndDate' });
    }

    self.dateFilterOptions.selectedId.extend({ required: !notRequired });
    self.startDate.extend({
        date: true,
        required: {
            onlyIf: function () { return self.dateFilterOptions.selectedId() === RadResponder.dateRangeOptions.custom.id && !notRequired; }
        }
    });
    self.endDate.extend({
        date: true,
        required: {
            onlyIf: function () { return self.dateFilterOptions.selectedId() === RadResponder.dateRangeOptions.custom.id && !notRequired; }
        }
    });
    self.vmOptions = {
        dateFilterOption: self.dateFilterOptions.selectedId,
        startDate: self.startDate,
        endDate: self.endDate,
    };

    self.updateTimesBasedOnDateFilter = function (dateFilterId) {
        switch (dateFilterId) {
            case RadResponder.dateRangeOptions.yearToDate.id:
                self.startDate(session.getDateTimeAsUtcString(session.getDateTime().startOf('year')));
                self.endDate(null);
                break;
            case RadResponder.dateRangeOptions.sevenDays.id:
                self.startDate(session.getDateTimeAsUtcString(session.getDateTime().startOf("day").subtract(6, "days")));
                self.endDate(null);
                break;
            case RadResponder.dateRangeOptions.thirtyDays.id:
                self.startDate(session.getDateTimeAsUtcString(session.getDateTime().startOf("day").subtract(29, "days")));
                self.endDate(null);
                break;
            case RadResponder.dateRangeOptions.ninetyDays.id:
                self.startDate(session.getDateTimeAsUtcString(session.getDateTime().startOf("day").subtract(90, "days")));
                self.endDate(null);
                break;
            case RadResponder.dateRangeOptions.thisMonth.id:
                self.startDate(session.getDateTimeAsUtcString(session.getDateTime().startOf("month")));
                self.endDate(null);
                break;
            case RadResponder.dateRangeOptions.lastMonth.id:
                self.startDate(session.getDateTimeAsUtcString(session.getDateTime().subtract(1, 'months').startOf("month")));
                self.endDate(session.getDateTimeAsUtcString(session.getDateTime().subtract(1, 'months').endOf('month')));
                break;
            case RadResponder.dateRangeOptions.sixMonths.id:
                self.startDate(session.getDateTimeAsUtcString(session.getDateTime().subtract(6, 'months')));
                self.endDate(null);
                break;
            case RadResponder.dateRangeOptions.yearToDate.id:
                self.startDate(session.getDateTimeAsUtcString(session.getDateTime().startOf('year')));
                self.endDate(null);
                break;
            case RadResponder.dateRangeOptions.today.id:
                self.startDate(session.getDateTimeAsUtcString(session.getDateTime().startOf('day')));
                self.endDate(null);
                break;
            case RadResponder.dateRangeOptions.twentyFourHours.id:
                self.startDate(session.getDateTimeAsUtcString(session.getDateTime().subtract(24, 'hours')));
                self.endDate(null);
                break;
            case RadResponder.dateRangeOptions.custom.id:
                break;
            case RadResponder.dateRangeOptions.none.id:
                self.startDate(null);
                self.endDate(null);
                break;
        }
    };

    self.dateFilterOptions.selectedId.subscribe(function (newId) {
        self.updateTimesBasedOnDateFilter(newId);
    });
    // Update start and end dates if custom default value set
    self.dateFilterOptions.selectedId.valueHasMutated();

    self.showDateSelection = ko.computed(function () {
        return self.dateFilterOptions.selectedId() === RadResponder.dateRangeOptions.custom.id;
    });

    self.showSummaryText = ko.computed(function () {
        return self.dateFilterOptions.selectedId() !== RadResponder.dateRangeOptions.custom.id && self.dateFilterOptions.selectedId() !== RadResponder.dateRangeOptions.none.id;
    });

    self.summaryText = ko.computed(function () {
        var startDateText = moment(self.startDate()).format('MM/DD/YYYY'),
            endDateText = self.endDate() ? moment(self.endDate()).format('MM/DD/YYYY') : "Today";
        return 'Selected Date Range: ' + startDateText + ' - ' + endDateText + '.';
    });

    return self;
};

RadResponder.graphDateRangeOptions = {
    today: {
        id: null,
        name: 'Just today',
    },
    twentyFourHours: {
        id: 1,
        name: 'Last 24 Hours',
    },
    sevenDays: {
        id: 2,
        name: 'Last 7 Days',
    },
    thirtyDays: {
        id: 3,
        name: 'Last 30 Days',
    },
    custom: {
        id: 4,
        name: 'Custom Date Range',
    },
    thisMonth: {
        id: 5,
        name: 'This Month',
    },
    lastMonth: {
        id: 6,
        name: 'Last Month',
    }
};

RadResponder.addressRenderer = (row) => {
    var addComma = (c, s, z) => {
        if ((c && s) || (c && z)) {
            return ',';
        }
        return '';
    };
    let smallFont = "10px";
    // if address info exists, display it under name
    if (!RadResponder.isEmpty(row.City) || !RadResponder.isEmpty(row.State) || !RadResponder.isEmpty(row.Zip_Code)) {
        return `<div>${row.Name}</div><div style='font-size: ${smallFont};'>${row.City ?? ''}${addComma(!RadResponder.isEmpty(row.City), !RadResponder.isEmpty(row.State), !RadResponder.isEmpty(row.Zip_Code))} ${row.State ?? ''} ${row.Zip_Code ?? ''}</div>`;
    }
    else if (!RadResponder.isEmpty(row.Name)) {
        return `<div>${row.Name}</div>`;
    }
    // Searching...
    else {
        return row.text;
    }
};

RadResponder.formatOrgSelection = (row) => {
    // placeholder text
    if (row.id === "") {
        return row.text;
    }
    // show name rather than formatted div text on selection
    return row.Name;
};

RadResponder.resourceClasses = {
    folder: "FOLDER",
    xls: "XLS",
    doc: "DOC",
    ppt: "PPT",
    zip: "ZIP",
    pdf: "PDF",
    vid: "VID",
    photo: "PHOTO",
    virtualFolder: "VIRTUALFOLDER",
    virtualDoc: "VIRTUALDOC",
    directory: "directory"
};


export default RadResponder;